(function () {
	'use strict';
	angular.module('jcsfApp').controller('reportsController', reportsController);

	reportsController.$inject = [
		'$controller',
		'$scope',
		'$filter',
		'$location',
		'events',
		'authService',
		'$window',
	];

	function reportsController(
		$controller,
		$scope,
		$filter,
		$location,
		events,
		authService,
		$window
	) {
		$controller('baseController', { $scope: $scope });

		var allDataOfProjct, allCenters;
		var vm = this;
		vm.fireHours = [];
		vm.fireSafety = [];
		vm.communityHours = [];
		vm.studentfireHours = [];
		vm.studentfireSafety = [];
		vm.studentcommunityHours = [];
		vm.summaryReportType = {};
		vm.selectedCenter = 0;
		vm.centers = [];
		vm.startDate = '';
		vm.endDate = '';
		vm.placementDate = '';
		vm.includePLC = false;
		vm.summaryCalendarYear = 0;
		vm.reportCriteria = {};
		vm.errorMessage = '';
		vm.scrollbar = '';
		vm.includePLCCert = false;
		vm.includeHasPLCCert = false;
		vm.selectedApprenticeship = 0;
		vm.selectedStudentType = 0;
		vm.studentPageUrl = $location.$$absUrl.split('/reports')[0] + '/student/';
		vm.startPage = true;
		vm.rsas = [];
		vm.selectedRsas = 0;
		vm.selectedFiscalYear = '';

		vm.centerName = function () {
			if (vm.reportCriteria && vm.reportCriteria.CenterId) {
				var s = vm.centers.filter(function (st) {
					return Number(vm.reportCriteria.CenterId) === Number(st.CenterId);
				})[0];
				vm.scrollbar = $('.div1').width($('.div2')[0].scrollWidth);
				$('.div1').css('width', $('.div2')[0].scrollWidth);
				$('.wrapper1').scroll(function () {
					$('.wrapper2').scrollLeft($('.wrapper1').scrollLeft());
				});
				$('.wrapper2').scroll(function () {
					$('.wrapper1').scrollLeft($('.wrapper2').scrollLeft());
				});

				if (s) return s.JCCCC;
			}

			vm.scrollbar = $('.div1').width($('.div2')[0].scrollWidth);
			$('.div1').css('width', $('.div2')[0].scrollWidth);
			$('.wrapper1').scroll(function () {
				$('.wrapper2').scrollLeft($('.wrapper1').scrollLeft());
			});
			$('.wrapper2').scroll(function () {
				$('.wrapper1').scrollLeft($('.wrapper2').scrollLeft());
			});
			return '';
		};
		vm.printElem = function (elem) {
			var mywindow = window.open('', 'PRINT', 'height=400,width=600');

			$('.table').css('display', 'contents');

			mywindow.document.write(
				'<html><head><title>' + vm.displayedReportName() + '</title>'
			);
			mywindow.document.write('</head><body >');
			mywindow.document.write(document.getElementById(elem).innerHTML);
			mywindow.document.write('</body></html>');

			if (
				vm.summaryReportType.reportSource == 'vwStudentProfile' &&
				vm.summaryReportType.name == 'Students with Maximum PLC Hours'
			) {
				$('.table').css('display', '');
			} else if (
				vm.summaryReportType.reportSource == 'vwStudentEligibleHiring'
			) {
				$('.table').css('display', '');
			} else if (
				vm.summaryReportType.reportSource == 'vwStudentProfile' ||
				vm.summaryReportType.reportSource == 'vwYouthAndVolunteerSummary' ||
				vm.summaryReportType.reportSource == 'vwFireHoursDetails' ||
				vm.summaryReportType.reportSource == '' ||
				vm.summaryReportType.reportSource == 'vwForestServiceDetailedHours' ||
				vm.summaryReportType.reportSource ==
					'vwNonFireFighterFireHireTrainingSummary' ||
				vm.summaryReportType.reportSource == 'vwSummary640Hours' ||
				vm.summaryReportType.reportSource == 'vwPLCSummaryHoursByStudent' ||
				vm.summaryReportType.reportSource == 'vwFS180016Summary' ||
				vm.summaryReportType.reportSource == 'vwStudentsWithPLCCertificates' ||
				vm.summaryReportType.reportSource ==
					'vwStudentsReferredforForestJobs' ||
				vm.summaryReportType.reportSource ==
					'vwStudentsReferredforConservationandFSJobs' ||
				vm.summaryReportType.reportSource == 'vwCommunityProjects' ||
				vm.summaryReportType.reportSource == 'vwFireHoursProjects' ||
				vm.summaryReportType.reportSource == 'vwForestServiceProjects'
			) {
				$('.table').css('display', 'block');
			} else {
				$('.table').css('display', '');
			}

			mywindow.document.close(); // necessary for IE >= 10
			mywindow.focus(); // necessary for IE >= 10*/

			mywindow.print();
			mywindow.close();

			return true;
		};
		vm.summaryReport = [];
		vm.totalField = function (fieldName) {
			if (
				vm.summaryReport &&
				vm.summaryReport.length &&
				vm.reportCriteria &&
				vm.reportCriteria.ReportSource
			) {
				var h = 0;
				angular.forEach(vm.summaryReport, function (r) {
					h = h + Number(r[fieldName]);
				});
				return h;
			}
		};
		vm.firefighterTotal = function () {
			if (
				vm.summaryReport &&
				vm.summaryReport.length &&
				vm.reportCriteria &&
				vm.reportCriteria.ReportSource === 'vwFireAssignmentSummary'
			) {
				var h = 0;
				angular.forEach(vm.summaryReport, function (r) {
					if (r.ResourceName === 'Fire Fighter')
						h = h + Number(r.AssignmentCount);
				});
				return h;
			}
			return 0;
		};
		vm.firefighterHoursTotal = function () {
			if (
				vm.summaryReport &&
				vm.summaryReport.length &&
				vm.reportCriteria &&
				vm.reportCriteria.ReportSource === 'vwFireAssignmentSummary'
			) {
				var h = 0;
				angular.forEach(vm.summaryReport, function (r) {
					if (r.ResourceName === 'Fire Fighter') h = h + Number(r.TotalHours);
				});
				return h;
			}
			return 0;
		};
		vm.femaleCount = function () {
			if (
				vm.summaryReport &&
				vm.summaryReport.length &&
				vm.reportCriteria &&
				(vm.reportCriteria.ReportSource === 'vwFireAssignmentSummary' ||
					vm.reportCriteria.ReportSource === 'vwYouthAndVolunteerSummary' ||
					vm.reportCriteria.ReportSource === 'vwFireHireTrainingSummary')
			) {
				var h = 0;
				angular.forEach(vm.summaryReport, function (r) {
					if (r.Gender === 'Female') h = h + Number(r.GenderCount);
				});
				return h;
			}
			return 0;
		};
		vm.maleCount = function () {
			if (
				vm.summaryReport &&
				vm.summaryReport.length &&
				vm.reportCriteria &&
				(vm.reportCriteria.ReportSource === 'vwFireAssignmentSummary' ||
					vm.reportCriteria.ReportSource === 'vwYouthAndVolunteerSummary' ||
					vm.reportCriteria.ReportSource === 'vwFireHireTrainingSummary')
			) {
				var h = 0;
				angular.forEach(vm.summaryReport, function (r) {
					if (r.Gender === 'Male') h = h + Number(r.GenderCount);
				});
				return h;
			}
			return 0;
		};
		vm.campCrewTotal = function () {
			if (
				vm.summaryReport &&
				vm.summaryReport.length &&
				vm.reportCriteria &&
				vm.reportCriteria.ReportSource === 'vwFireAssignmentSummary'
			) {
				var h = 0;
				angular.forEach(vm.summaryReport, function (r) {
					if (r.ResourceName === 'Camp Crew') h = h + Number(r.AssignmentCount);
				});
				return h;
			}
			return 0;
		};
		vm.campCrewHoursTotal = function () {
			if (
				vm.summaryReport &&
				vm.summaryReport.length &&
				vm.reportCriteria &&
				vm.reportCriteria.ReportSource === 'vwFireAssignmentSummary'
			) {
				var h = 0;
				angular.forEach(vm.summaryReport, function (r) {
					if (r.ResourceName === 'Camp Crew') h = h + Number(r.TotalHours);
				});
				return h;
			}

			return 0;
		};
		vm.assignmentTypeTotal = function () {
			if (
				vm.summaryReport &&
				vm.summaryReport.length &&
				vm.reportCriteria &&
				vm.reportCriteria.ReportSource === 'vwFireAssignmentSummary'
			) {
				var h = 0;
				angular.forEach(vm.summaryReport, function (r) {
					h = h + Number(r.AssignmentCount);
				});
				return h;
			}
			return 0;
		};
		vm.projectCount = function () {
			if (
				vm.summaryReport &&
				vm.summaryReport.length &&
				vm.reportCriteria &&
				vm.reportCriteria.ReportSource === 'vwFireAssignmentSummary'
			) {
				var centers = [];
				var h = 0;
				var jcenters = [];
				angular.forEach(vm.summaryReport, function (r) {
					var match = $filter('filter')(jcenters, function (p) {
						return p.JCCCC === r.JCCCC;
					})[0];
					if (!match) {
						jcenters.push({ JCCCC: r.JCCCC, ProjectCount: r.ProjectCount });
					}
				});
				angular.forEach(jcenters, function (c) {
					h = h + Number(c.ProjectCount);
				});
				return h;
			}
			return 0;
		};
		vm.maxHours = 600;
		vm.totalAcres = function () {
			var proIds = [];
			for (var report of vm.summaryReport) {
				var match = proIds.find(function (id) {
					return Number(id.ProjectId) === Number(report.ProjectId);
				});
				if (!match) {
					proIds.push({ ProjectId: report.ProjectId, Acres: report.Acres });
				}
			}

			return proIds.reduce(function (acc, id) {
				return acc + Number(id.Acres);
			}, 0);
		};
		vm.ApprenticeshipList = [
			{ name: 'Conservation', title: 'Conservation' },
			{ name: 'Forest Service', title: 'Forest Service' },
			{ name: 'None', title: 'None' },
		];
		vm.StudentTypeList = [
			{ name: 'All', title: 'All' },
			{ name: 'Active', title: 'Active' },
			{ name: 'Archived', title: 'Archived' },
		];
		vm.PLCList = [
			{ name: 'PLC', title: 'PLC' },
			{ name: 'Non PLC', title: 'Non PLC' },
			{ name: 'Both', title: 'Both' },
		];
		vm.summaryReportList = [
			{
				name: 'Rural Development Hours Detailed Report',
				reportSource: 'vwCommunityHoursDetails',
				title: 'Rural Development Hours Detailed Report',
				showPLC: false,
				sortOrder: 'JCCenter',
				requireCenter: false,
			},
			{
				name: 'Rural Development Projects Report',
				reportSource: 'vwCommunityProjects',
				title: 'Rural Development Projects Report',
				showPLC: false,
				sortOrder: '[Center Name]',
				requireCenter: false,
			}, //add Community projects report option in list
			{
				name: 'Fire Hours Projects Report',
				reportSource: 'vwFireHoursProjects',
				title: 'Fire Hours Projects Report',
				showPLC: false,
				sortOrder: '[Center Name]',
				requireCenter: false,
			},
			{
				name: 'Fire Hours Detailed Report',
				reportSource: 'vwFireHoursDetails',
				title: 'Forest Service Detail Hours Report',
				showPLC: false,
				sortOrder: 'LastName',
				requireCenter: false,
			},
			{
				name: 'Fire Hours Detailed Report - Without Training hours',
				reportSource: 'vwFireHoursDetails',
				title: 'Forest Service Detail Hours Report - New',
				showPLC: false,
				sortOrder: 'LastName',
				requireCenter: false,
			},
			{
				name: 'Forest Service Detailed Hours Report',
				reportSource: 'vwForestServiceDetailedHours',
				title: 'Forest Service Detailed Hours Report',
				showPLC: false,
				sortOrder: 'JCCenter',
				requireCenter: false,
			},
			{
				name: 'Forest Service Project Summary Hours',
				reportSource: 'vwForestServiceProjects',
				title: 'Forest Service Project Summary Hours',
				showPLC: false,
				sortOrder: '[Center Name]',
				requireCenter: false,
			}, //add forest service project summary report option in report list
			{
				name: 'FS-1800-16 Summary Report',
				reportSource: 'vwFS180016Summary',
				title: 'FS-1800-16 Summary Report',
				showPLC: false,
				sortOrder: 'MainArea,SubArea',
				requireCenter: false,
			},
			{
				name: 'Individual Student PLC Hours',
				reportSource: 'vwIndividualStudentPLCHours',
				title: 'Individual Student PLC Hours',
				showPLC: false,
				sortOrder: 'StudentName',
				requireCenter: false,
			},
			{
				name: 'Placements Summary Report',
				reportSource: 'vwStudentProfile',
				title: 'Placements Summary Report',
				showPLC: false,
				sortOrder: 'LastName',
				requireCenter: false,
			}, //add Placements summary report option in list
			{
				name: 'Score Card Report',
				reportSource: 'vwScoreCard',
				title: 'Score Card Report',
				showPLC: false,
				requireCenter: false,
			}, //add ScoreCard report option in list
			{
				name: 'Student Profile Report',
				reportSource: 'vwStudentProfile',
				title: 'Student Profile Detail Listing',
				showPLC: false,
				sortOrder: 'CenterName',
				showDates: false,
				requireCenter: false,
			},
			{
				name: 'Students Referred for Forest Service Jobs',
				reportSource: 'vwStudentsReferredforForestJobs',
				title: 'Students Referred for Forest Service Jobs',
				showPLC: false,
				sortOrder: '[Center Name]',
				requireCenter: false,
				showFiscalYear: true,
			},
			{
				name: 'Students Referred for Conservation and Forest Service Jobs',
				reportSource: 'vwStudentsReferredforConservationandFSJobs',
				title: 'Students Referred for Conservation and Forest Service Jobs',
				showPLC: false,
				sortOrder: '[Center Name]',
				requireCenter: false,
				showFiscalYear: true,
			},
			{
				name: 'Students with Maximum PLC Hours',
				reportSource: 'vwStudentProfile',
				title: 'Students with Maximum PLC Hours',
				showPLC: false,
				sortOrder: 'CenterName',
				showDates: false,
				requireCenter: false,
			}, //add Students with Maximum PLC hours option in list
			{
				name: 'Students with PLC Certificates',
				reportSource: 'vwStudentsWithPLCCertificates',
				title: 'Students with PLC Certificates',
				showPLC: false,
				sortOrder: '[Center Name]',
				requireCenter: false,
			}, //add Students with PLC Certificates option in list
			{
				name: 'Students Eligible for Hiring',
				reportSource: 'vwStudentEligibleHiring',
				title: 'Students Eligible for Hiring',
				showPLC: false,
				sortOrder: 'CenterName',
				showDates: false,
				requireCenter: false,
			}, //add Students with Maximum PLC hours option in list
			{
				name: 'Summary of Hours by Student',
				reportSource: 'vwSummary640Hours',
				title: 'Summary of Hours by Student',
				showPLC: true,
				sortOrder: 'LastName',
				requireCenter: false,
				showMaxHours: true,
			},
			{
				name: 'Total Project Hours by Center',
				reportSource: 'vwTotalProjectHoursByCenter',
				title: 'Total Project Hours by Center',
				showPLC: false,
				sortOrder: 'CenterId',
				requireCenter: false,
			},
			{
				name: 'Users Report',
				reportSource: 'vwUsers',
				title: 'Users Report',
				showPLC: false,
				sortOrder: 'FirstName',
				showDates: false,
				requireCenter: false,
			}, //add Usrs report option in list
		];
		vm.canGetSummaryReport = function () {
			if (vm.startPage == true) {
				return false;
			}
			if (
				vm.summaryReportType && [
					(vm.summaryReportType.reportSource === 'vwStudentProfile' &&
						(vm.summaryReportType.name == 'Student Profile Report' ||
							vm.summaryReportType.name ==
								'Students with Maximum PLC Hours')) ||
						vm.summaryReportType.reportSource === 'vwUsers' ||
						vm.summaryReportType.reportSource === 'vwStudentEligibleHiring',
				]
			) {
				return true;
			}
			//if (vm.summaryReportType && vm.summaryReportType.reportSource === 'vwUsers' && vm.selectedCenter > 0) { return true; }
			if (
				vm.summaryReportType &&
				!vm.summaryReportType.requiresCenter &&
				vm.startDate &&
				vm.startDate.length > 5 &&
				vm.endDate &&
				vm.endDate.length > 5
			) {
				return true;
			}
			return (
				vm.summaryReportType &&
				vm.summaryReportType.reportSource &&
				vm.selectedCenter > 0 &&
				vm.startDate &&
				vm.startDate.length > 5 &&
				vm.endDate &&
				vm.endDate.length > 5
			);
		};
		vm.resources = [];
		vm.projects = [];
		vm.selectedResource = '';
		vm.selectedProject = 0;
		vm.selectedAssignmentType = 0;
		vm.selectedPLC = 0;
		vm.selectedProjectResourceOrderNo = '';
		vm.changeCenter = centerChanged;
		vm.fiscalYearChanged = fiscalYearUpdated;
		vm.reportDate = function () {
			var today = new Date();
			var dd = today.getDate();
			var mm = today.getMonth() + 1; //January is 0!
			var yyyy = today.getFullYear();

			if (dd < 10) {
				dd = '0' + dd;
			}

			if (mm < 10) {
				mm = '0' + mm;
			}

			today = mm + '/' + dd + '/' + yyyy;
			return today;
		};
		vm.displayedReportName = function () {
			if (vm.reportCriteria && vm.reportCriteria.ReportSource) {
				var s = vm.summaryReportList.filter(function (st) {
					return vm.reportCriteria.ReportSource === st.reportSource;
				})[0];
				if (s) return vm.reportCriteria.ReportName;
			}
			return '';
		};
		vm.getSummaryReport = function (rpt) {
			if (vm.startDate == '' || vm.endDate == '') {
				vm.startDate = '01/01/2010';
				vm.endDate = vm.reportDate();
			}

			vm.reportCriteria = {};
			vm.reportCriteria = {
				ReportSource: rpt.reportSource,
				CalendarYear: vm.summaryCalendarYear,
				StartDate: vm.startDate,
				EndDate: vm.endDate,
				JobPlacementDate: vm.placementDate,
				SortOrder: rpt.sortOrder,
				CenterId: vm.selectedCenter,
				ReportName: rpt.name,
			};
			if (rpt.showPLC) {
				vm.reportCriteria.IsPLC = vm.includePLC;
			}
			if (
				rpt.reportSource === 'vwStudentProfile' &&
				vm.summaryReportType.name == 'Student Profile Report' &&
				vm.summaryCalendarYear > 2015
			) {
				delete vm.reportCriteria.CalendarYear;
				vm.reportCriteria.StartDate =
					'10/1/' + (Number(vm.summaryCalendarYear) - 1);
				vm.reportCriteria.EndDate = '9/30/' + vm.summaryCalendarYear;
				if (vm.selectedStudentType)
					vm.reportCriteria.StudentType = vm.selectedStudentType.name;
			}
			if (
				rpt.reportSource === 'vwStudentProfile' &&
				vm.summaryReportType.name == 'Student Profile Report'
			) {
				if (vm.selectedStudentType)
					vm.reportCriteria.StudentType = vm.selectedStudentType.name;
				if (vm.reportCriteria && vm.reportCriteria.CenterId) {
					var s = vm.centers.filter(function (st) {
						return Number(vm.reportCriteria.CenterId) === Number(st.CenterId);
					})[0];
					vm.reportCriteria.CenterName = s.JCCCC;
				}
			}
			if (
				rpt.reportSource === 'vwStudentProfile' &&
				vm.summaryReportType.name == 'Placements Summary Report' &&
				vm.summaryCalendarYear > 2015
			) {
				delete vm.reportCriteria.CalendarYear;
				vm.reportCriteria.StartDate =
					'10/1/' + (Number(vm.summaryCalendarYear) - 1);
				vm.reportCriteria.EndDate = '9/30/' + vm.summaryCalendarYear;
				if (vm.selectedApprenticeship)
					vm.reportCriteria.Apprenticeship = vm.selectedApprenticeship.name;
			}
			if (
				rpt.reportSource === 'vwStudentProfile' &&
				vm.summaryReportType.name == 'Placements Summary Report'
			) {
				if (vm.selectedApprenticeship)
					vm.reportCriteria.Apprenticeship = vm.selectedApprenticeship.name;
			}
			if (rpt.reportSource === 'vwIndividualStudentPLCHours') {
				if (vm.reportCriteria && vm.reportCriteria.CenterId) {
					var s = vm.centers.filter(function (st) {
						return Number(vm.reportCriteria.CenterId) === Number(st.CenterId);
					})[0];
					vm.reportCriteria.CenterName = s.JCCCC;
				}
			}
			if (
				rpt.reportSource === 'vwUsers' ||
				rpt.reportSource === 'vwStudentEligibleHiring' ||
				(rpt.reportSource === 'vwStudentProfile' &&
					vm.summaryReportType.name == 'Students with Maximum PLC Hours')
			) {
				//delete vm.reportCriteria.CalendarYear;
				//vm.reportCriteria.StartDate = '10/1/' + (Number(vm.summaryCalendarYear) - 1);
				//vm.reportCriteria.EndDate = '9/30/' + vm.summaryCalendarYear;

				if (vm.reportCriteria && vm.reportCriteria.CenterId) {
					var s = vm.centers.filter(function (st) {
						return Number(vm.reportCriteria.CenterId) === Number(st.CenterId);
					})[0];
					vm.reportCriteria.CenterName = s.JCCCC;
				}
			}
			if (
				rpt.reportSource === 'vwFireHoursDetails' ||
				rpt.reportSource === 'vwFireProjectTypeAcresHoursSummary'
			) {
				if (vm.selectedProject)
					vm.reportCriteria.ProjectId = vm.selectedProject;
				if (vm.selectedResource && vm.selectedResource.length)
					vm.reportCriteria.ProjectType = vm.selectedResource;
			}
			if (rpt.reportSource === 'vwFS180016Summary') {
				if (vm.selectedRsas)
					vm.reportCriteria.PartnerOrganization = vm.selectedRsas.Unit;
			}
			if (rpt.reportSource === 'vwFireAssignmentSummary') {
				if (vm.selectedProject)
					vm.reportCriteria.ProjectId = vm.selectedProject;
				if (vm.selectedAssignmentType)
					vm.reportCriteria.AssignmentType = vm.selectedAssignmentType;
				if (
					vm.selectedProjectResourceOrderNo &&
					vm.selectedProjectResourceOrderNo.length
				)
					vm.reportCriteria.ProjectResourceOrderNo =
						vm.selectedProjectResourceOrderNo;
			}
			if (
				rpt.reportSource === 'vwCommunityProjects' ||
				rpt.reportSource === 'vwFireHoursProjects' ||
				rpt.reportSource === 'vwStudentsWithPLCCertificates' ||
				rpt.reportSource === 'vwStudentsReferredforForestJobs' ||
				rpt.reportSource === 'vwStudentsReferredforConservationandFSJobs' ||
				rpt.reportSource === 'vwForestServiceProjects'
			) {
				if (vm.reportCriteria && vm.reportCriteria.CenterId) {
					var s = vm.centers.filter(function (st) {
						return Number(vm.reportCriteria.CenterId) === Number(st.CenterId);
					})[0];
					vm.reportCriteria.CenterName = s.JCCCC;
				}
			}
			if (rpt.reportSource === 'vwScoreCard') {
			}
			if (
				rpt.reportSource === 'vwCommunityHoursDetails' ||
				rpt.reportSource === 'vwCommunityProjects' ||
				rpt.reportSource === 'vwFireHoursProjects'
			) {
				if (vm.selectedPLC) vm.reportCriteria.PLCValue = vm.selectedPLC.name;
			}
			if (rpt.reportSource === 'vwSummary640Hours') {
				vm.reportCriteria.HasPLCCertificate = vm.includePLC;
				vm.reportCriteria.MaxTotal = vm.maxHours;
			}
			//if (rpt.reportSource === 'vwCommunityProjects') {
			//    vm.reportCriteria.IsPLC = vm.includePLC;
			//}
			$scope.publish(events.message._GET_SUMMARY_REPORT_LIST_, [
				vm.reportCriteria,
			]);
		};
		vm.fs1800_16 = [];
		vm.PLCTotalHours = [];
		vm.youthAndVolunteer = [];
		vm.startDate = '';
		vm.endDate = '';
		vm.calendarYears = [2016, 2017, 2018, 2019, 2020, 2021];
		vm.calendarYear = 0; //should be 2019 if we unhide claendar year
		vm.isPLC = true;
		vm.sortType = 'LastName';
		vm.sortReverse = false;
		vm.report = '';
		authService.fillAuthData();
		vm.studentResources = {};
		var authentication = authService.authentication;
		vm.canRunStudentFireHours = function () {
			return (
				vm.report === 'StudentFireHours' &&
				moment(vm.startDate, 'MM/DD/YYYY', true).isValid() &&
				moment(vm.endDate, 'MM/DD/YYYY', true).isValid()
			);
		};
		vm.canRunStudentFSHours = function () {
			return (
				vm.report === 'StudentFireSafety' &&
				moment(vm.startDate, 'MM/DD/YYYY', true).isValid() &&
				moment(vm.endDate, 'MM/DD/YYYY', true).isValid()
			);
		};
		vm.canRunStudentCommunityHours = function () {
			return (
				vm.report === 'StudentCommunity' &&
				moment(vm.startDate, 'MM/DD/YYYY', true).isValid() &&
				moment(vm.endDate, 'MM/DD/YYYY', true).isValid()
			);
		};
		vm.canRunFS1800 = function () {
			return (
				vm.report === 'FS1800_16' &&
				moment(vm.startDate, 'MM/DD/YYYY', true).isValid() &&
				moment(vm.endDate, 'MM/DD/YYYY', true).isValid()
			);
		};
		vm.canRunYouthAndVolunteer = function () {
			return (
				vm.report === 'YouthAndVolunteer' &&
				moment(vm.startDate, 'MM/DD/YYYY', true).isValid() &&
				moment(vm.endDate, 'MM/DD/YYYY', true).isValid()
			);
		};
		vm.canRunPLCTotalHours = function () {
			return (
				vm.report === 'PLCTotalHours' &&
				moment(vm.startDate, 'MM/DD/YYYY', true).isValid() &&
				moment(vm.endDate, 'MM/DD/YYYY', true).isValid()
			);
		};
		vm.tabs = [
			//{ title: 'PowerBI Reports', url: '/app/reports/views/bireportViews.html' },
			{
				title: 'Summary Reports',
				url: '/app/reports/views/reportSummaries.html',
			},
			//{ title: 'Report Extracts', url: '/app/reports/views/reportExtracts.html' }
		];
		function openBIWindow(src, title) {
			$window.open(
				src,
				title,
				'toolbar=no,scrollbars=yes,resizable=yes,width=900,height=800,left=600,top=150'
			);
			return true;
		}
		vm.biSPRReport = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=45fcb0dd-b8b5-48c8-a8c2-d014bb2e7912&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLWVhc3QtYS1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9';
			var title = 'Active Student Profile Report';
			return openBIWindow(src, title);
		};
		vm.biFSDReport = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=a37dd876-910a-43b2-ada7-dfa2d4e89a9c&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a&noSignUpCheck=1';
			var title = 'Forest Service Detailed Hours Report';
			return openBIWindow(src, title);
		};
		vm.biCHDReport = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=7f3517ea-5e06-4b3d-890c-d4eb18d8050d&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'Rural Development Hours Detailed Report';
			return openBIWindow(src, title);
		};
		vm.biYVSReport = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=50709b93-ce3e-44df-a051-43ac2c9725f3&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = '(640) Summary of Hours by Student';
			return openBIWindow(src, title);
		};
		vm.biPLCReport = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=a163e6cb-d7f0-4a9a-b0eb-1a09c22d57e6&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'PLC Summary Hours by Student';
			return openBIWindow(src, title);
		};
		vm.biFSSReport = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=405ba10d-92c4-45ba-b77f-c401f9b861f1&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'FS-1800-16 Summary Report';
			return openBIWindow(src, title);
		};
		vm.biYAVReport = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=392075f3-7d73-49a1-932f-b5a64698e0ac&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'Youth and Volunteer Summary Report';
			return openBIWindow(src, title);
		};
		vm.biFHDReport = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=c51b8d6c-b12d-4f22-8b94-9415dc5c48d0&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'Fire Hours Detailed Report';
			return openBIWindow(src, title);
		};
		vm.biFPAReport = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=d3a59e23-d7ab-451a-8e42-25edc9481eb1&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'Fire Project Type, Acres, Hours, Summary';
			return openBIWindow(src, title);
		};
		vm.biFASReport = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=c51b8d6c-b12d-4f22-8b94-9415dc5c48d0&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'Fire Assignment Summary Report';
			return openBIWindow(src, title);
		};
		vm.biFHTOReport = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=db441d62-1433-4bee-98ac-2a95a0ad2aff&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'Fire Hiring and Trainee – Other Support Report';
			return openBIWindow(src, title);
		};
		vm.biFHTFeport = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=23fcfaed-8129-490b-8d8c-48ac987d009d&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'Fire Hiring and Trainee – Fire Fighter Report';
			return openBIWindow(src, title);
		};
		vm.biStudentGrad = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=7701b576-a7cd-407e-bfe0-e26198756deb&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'Student Graduation Report';
			return openBIWindow(src, title);
		};
		vm.biYVSReport2 = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=7351d30c-a44d-4392-84b3-0006c40acd2f&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'Summary of Hours by Student';
			return openBIWindow(src, title);
		};
		vm.biUsers = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=9b89d670-2285-4098-8ba8-0c55fdc33006&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'Users Report';
			return openBIWindow(src, title);
		};
		vm.biScorecard = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=2662a6b1-2d05-4074-bd16-5584a8bb5534&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'Score Card Report';
			return openBIWindow(src, title);
		};
		vm.biFireDetailed = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=7a270762-138c-47e1-8335-9e5782422159&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'Fire Hours Detailed Report';
			return openBIWindow(src, title);
		};
		vm.biTotalPorjectHours = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=048b9a42-eff1-4d25-b49c-b2a47c771bb5&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'Total Project Hours by Center';
			return openBIWindow(src, title);
		};

		vm.biFSProjects = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=a2c5ce4a-217c-46fb-8720-e76248417bff&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'Forest Service Projects Report';
			return openBIWindow(src, title);
		};
		vm.biCommProects = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=058285cd-8771-4639-b60a-5f5e89c6547b&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'Rural Development Projects Report';
			return openBIWindow(src, title);
		};
		vm.biStudentPLC = function () {
			var src =
				'https://app.powerbi.com/reportEmbed?reportId=c31d7574-7bb3-4769-bfaf-08ce483ee0e9&autoAuth=true&ctid=e9b6e61e-d5a4-4eec-b2f4-579864a1609a';
			var title = 'Students with PLC Certificates';
			return openBIWindow(src, title);
		};

		//vm.currentTab = '/app/reports/views/bireportViews.html';
		vm.currentTab = '/app/reports/views/reportSummaries.html';
		vm.onClickTab = function (tab) {
			if (tab.url === '/app/reports/views/reportViews.html') {
				clearResults();
			}
			if (tab.url === '/app/reports/views/reportExtracts.html') {
				clearResults();
				vm.calendarYear = 0; //should be 2020 if we unhide calendar year
			}

			vm.currentTab = tab.url;
		};
		vm.isActiveTab = function (tabUrl) {
			return tabUrl === vm.currentTab;
		};
		vm.exportToCSV = function () {
			var lst = [];
			switch (vm.summaryReportType.reportSource) {
				case 'vwStudentProfile':
					if (vm.summaryReportType.name == 'Placements Summary Report') {
						lst.push({
							0:
								'Date Ran Report : ' +
								(new Date().getMonth() +
									1 +
									'/' +
									new Date().getDate() +
									'/' +
									new Date().getFullYear()),
						});
						lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
						lst.push({ 0: 'Total Hourly : ' + vm.totalField('Salary') });
						lst.push({
							0: 'First Name',
							1: 'MI',
							2: 'Last Name',
							3: 'CIS No',
							4: 'Center',
							5: 'JC Start Date',
							6: 'Graduation Date',
							7: 'Has been Placed',
							8: 'Job Placement Date',
							9: 'Placement Type',
							10: 'Placement Type Other',
							11: 'Apprenticeship Hire',
							12: 'Employer',
							13: 'Job Title',
							14: 'Unit Location',
							15: 'Hourly',
							16: 'Hiring Authority',
							17: 'Placement Verified',
							18: 'Supporting Document Type',
						});

						vm.summaryReport.forEach(function (item) {
							lst.push({
								0: item.FirstName,
								1: item.MiddleInitial,
								2: item.LastName,
								3: item.CISNo,
								4: item.CenterName,
								5: item.JCStartDate,
								6: item.JCGraduationDate,
								7: item.EmploymentFirePlacement,
								8: item.PlacementDate,
								9: item.PlacementType,
								10: item.PlacementTypeOther,
								11: item.Apprenticeship,
								12: item.Employer,
								13: item.JobTitle,
								14: item.JobLocations,
								15: item.Salary,
								16: item.HiringAuthority,
								17: item.PlacementVerified,
								18: item.SupportingDocumentType,
							});
						});
					} else if (
						vm.summaryReportType.name == 'Students with Maximum PLC Hours'
					) {
						lst.push({
							0:
								'Date Ran Report : ' +
								(new Date().getMonth() +
									1 +
									'/' +
									new Date().getDate() +
									'/' +
									new Date().getFullYear()),
						});
						lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
						lst.push({ 0: 'Total PLC Hours : ' + vm.totalField('PLCHours') });
						lst.push({
							0: 'Center',
							1: 'First Name',
							2: 'MI',
							3: 'Last Name',
							4: 'PLC Hours',
							5: 'Has PLC Certificate',
						});

						vm.summaryReport.forEach(function (item) {
							lst.push({
								//0: item.CenterName, 1: item.FirstName, 2: item.MiddleInitial, 3: item.LastName, 4: item.PLCHours, 5: item.GeneratePLCCertificate
								0: item.CenterName,
								1: item.FirstName,
								2: item.MiddleInitial,
								3: item.LastName,
								4: item.PLCHours,
								5: item.PLCCertificateRecieved,
							});
						});
					} else {
						lst.push({
							0:
								'Date Ran Report : ' +
								(new Date().getMonth() +
									1 +
									'/' +
									new Date().getDate() +
									'/' +
									new Date().getFullYear()),
						});
						lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
						lst.push({
							0: 'Total FS Hours : ' + vm.totalField('fsTotalHours'),
						});
						lst.push({
							0: 'Total Fire Hours : ' + vm.totalField('fhTotalHours'),
						});
						lst.push({
							0:
								'Total Rural Development Hours : ' +
								vm.totalField('chTotalHours'),
						});
						lst.push({ 0: 'Total Hours : ' + vm.totalField('TotalHours') });
						lst.push({ 0: 'Total PLC Hours : ' + vm.totalField('PLCHours') });
						lst.push({
							0: 'Center',
							1: 'First Name',
							2: 'MI',
							3: 'Last Name',
							4: 'CIS Number',
							5: 'Gender',
							6: 'Education Level',
							7: 'Primary Phone number',
							8: 'Personal Email address',
							9: 'JC Start date',
							10: 'Student Trade',
							11: 'Credentials',
							12: 'Fire Positions',
							13: 'Graduated',
							14: 'Graduation Date',
							15: 'Refer For Job',
							16: 'Has been placed',
							17: 'Placement Date',
							18: 'Placement Type',
							19: 'Placement Type Other',
							20: 'Employer',
							21: 'Job Title',
							22: 'Apprenticeship hire',
							23: 'Unit location',
							24: 'Salary',
							25: 'Employer Other',
							26: 'Hiring Authority',
							27: 'FS Hours',
							28: 'Fire Hours',
							29: 'Rural Development Hours',
							30: 'Total Hours',
							31: 'PLC Certificate Recieved',
							32: 'Date ofPLC Certificate',
							33: 'Student Bio',
							34: 'Supervisor Remarks',
							35: 'Entry Created',
							36: 'Entry Last Updated',
							37: 'Placement Verified',
							38: 'PLC Hours',
							39: 'FS Phone Number',
							40: 'FS Email Address',
							41: 'Generate PLC Certificate',
							42: 'Supporting Document Type',
							43: 'Admin Comments',
						});

						vm.summaryReport.forEach(function (item) {
							lst.push({
								0: item.CenterName,
								1: item.FirstName,
								2: item.MiddleInitial,
								3: item.LastName,
								4: item.CISNo,
								5: item.Gender,
								6: item.EducationLevel,
								7: item.PrimaryPhoneNumber,
								8: item.PersonalEmailAddress,
								9: item.JCStartDate,
								10: item.StudentTrade,
								11: item.Credentials,
								12: item.ICSPosition,
								13: item.Graduated,
								14: item.JCGraduationDate,
								15: item.ReferForJob,
								16: item.EmploymentFirePlacement,
								17: item.PlacementDate,
								18: item.PlacementType,
								19: item.PlacementTypeOther,
								20: item.Employer,
								21: item.JobTitle,
								22: item.Apprenticeship,
								23: item.UnitLocation,
								24: item.Salary,
								25: item.EmployerOther,
								26: item.HiringAuthority,
								27: item.fsTotalHours,
								28: item.fhTotalHours,
								29: item.chTotalHours,
								30: item.TotalHours,
								31: item.PLCCertificateRecieved,
								32: item.PLCCertificateDate,
								33: item.StudentBio,
								34: item.SupervisorRemarks,
								35: item.CreatedDate,
								36: item.LastUpdated,
								37: item.PlacementVerified,
								38: item.PLCHours,
								39: item.FSPhoneNumber,
								40: item.FSEmailAddress,
								41: item.GeneratePLCCertificate,
								42: item.SupportingDocumentType,
								43: item.AdminComments,
							});
						});
					}

					return lst;
				case 'vwStudentEligibleHiring':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({ 0: 'Total PLC Hours : ' + vm.totalField('PLCHours') });
					lst.push({
						0: 'Center',
						1: 'First Name',
						2: 'MI',
						3: 'Last Name',
						4: 'PLC Hours',
						5: 'Has PLC Certificate',
						6: 'Has this student completed a work based learning PLC assignment?',
						7: 'Is this student ready for a work based learning PLC assignment?',
					});

					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.CenterName,
							1: item.FirstName,
							2: item.MiddleInitial,
							3: item.LastName,
							4: item.PLCHours,
							5: item.PLCCertificateRecieved,
							6: item.WBLCompleted,
							7: item.WBLStarted,
						});
					});

					return lst;
				case 'vwForestServiceDetailedHours':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({
						0: 'Total Actual Hours : ' + vm.totalField('ActualHours'),
					});
					lst.push({
						0: 'Center',
						1: 'Students Name',
						2: 'Project Title',
						3: 'Dispatch Date',
						4: 'Return Date',
						5: 'Hours',
						6: 'Staff',
						7: 'Focus Area',
						8: 'Sub Area',
						9: 'Partner Org',
						10: 'Project Site',
						11: 'Is PLC',
						12: 'Comments',
						13: 'Creator',
						14: 'Entry Created',
						15: 'Entry Last updated',
						16: 'GAOA Hours',
						17: 'HistoriCorps Hours',
						18: 'State',
						19: 'Justice40',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.JCCenter,
							1: item.StudentName,
							2: item.ProjectName,
							3: item.DispatchDate,
							4: item.ReturnedDate,
							5: item.ActualHours,
							6: item.StaffResponsible,
							7: item.FocusArea,
							8: item.SubArea,
							9: item.PartnerOrg,
							10: item.ProjectSite,
							11: item.IsPLC,
							12: item.Comments,
							13: item.Creator,
							14: item.CreatedDate,
							15: item.UpdateDate,
							16: item.GAOAHours,
							17: item.HistoriCorpsHours,
							18: item.State,
							19: item.Justice40,
						});
					});

					return lst;
				case 'vwFireProjectTypeAcresHoursSummary':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({ 0: 'Total Acres : ' + vm.totalField('Acres') });
					lst.push({
						0: 'Total Actual Hours : ' + vm.totalField('ActualHours'),
					});
					lst.push({
						0: 'JC Center',
						1: 'Proj. Type',
						2: 'Project Title',
						3: 'Acres',
						4: 'Actual Hours',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.JCCenter,
							1: item.ProjectType,
							2: item.ProjectTitle,
							3: item.Acres,
							4: item.ActualHours,
						});
					});
					return lst;
				case 'vwYouthAndVolunteerSummary':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({ 0: 'Total Male Count : ' + vm.maleCount() });
					lst.push({ 0: 'Total Female Count : ' + vm.femaleCount() });
					lst.push({ 0: 'Total Hours : ' + vm.totalField('TotalHours') });
					lst.push({
						0: 'Fiscal Year',
						1: 'RSA',
						2: 'Deputy Area',
						3: 'Type Work',
						4: 'Partner Org.',
						5: 'Prog. Partner Type',
						6: 'Nat. For.WetLands',
						7: 'Focus Area',
						8: 'Gender',
						9: 'Gender Count',
						10: 'Total Hours',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.CalendarYear,
							1: item.RSAPartner,
							2: item.DeputyArea,
							3: item.TypeOfWork,
							4: item.PartnerOrg,
							5: item.ProgramPartnerType,
							6: item.NationalForestGrasslands,
							7: item.FocusArea,
							8: item.Gender,
							9: item.GenderCount,
							10: item.TotalHours,
						});
					});
					return lst;
				case 'vwFireHoursDetails':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });

					if (vm.summaryReportType.name == 'Fire Hours Detailed Report') {
						lst.push({ 0: 'Total Hours : ' + vm.totalField('ActualHours') });
						lst.push({
							0: 'First Name',
							1: 'MI',
							2: 'Last Name',
							3: 'CIS No',
							4: 'Center',
							5: 'Project Title',
							6: 'Agency',
							7: 'Partner Organization',
							8: 'Project Site Location',
							9: 'Project Type',
							10: 'Other',
							11: 'Hazard Type',
							12: 'Project Resource Order Number',
							13: 'Staff Responsible',
							14: 'Project Description',
							15: 'Dispatch Date',
							16: 'Returned Date',
							17: 'Hours',
							18: 'IsPLC',
							19: 'Assignment Type',
							20: 'Comments',
							21: 'Project Verified',
							22: 'Creator',
							23: 'Entry Created',
							24: 'Entry Last Updated',
							25: 'Acres',
							26: 'State',
							27: 'Justice40',
							28: 'SPIS',
						});
						vm.summaryReport.forEach(function (item) {
							lst.push({
								0: item.FirstName,
								1: item.MiddleInitial,
								2: item.LastName,
								3: item.CISNo,
								4: item.JCCenter,
								5: item.ProjectTitle,
								6: item.Agency,
								7: item.PartnerOrganization,
								8: item.ProjectSiteLocation,
								9: item.ProjectType,
								10: item.ProjectTypeOther,
								11: item.HazardType,
								12: item.ProjectResourceOrderNo,
								13: item.StaffResponsible,
								14: item.ProjectDescription,
								15: item.DispatchDate,
								16: item.ReturnedDate,
								17: item.ActualHours,
								18: item.IsPLC,
								19: item.AssignmentType,
								20: item.Comments,
								21: item.ProjectVerified,
								22: item.Creator,
								23: item.CreatedDate,
								24: item.LastUpdated,
								25: item.Acres,
								26: item.State,
								27: item.Justice40,
								28: item.SPIS,
							});
						});
					} else {
						lst.push({
							0: 'First Name',
							1: 'MI',
							2: 'Last Name',
							3: 'CIS No',
							4: 'Center',
							5: 'Project Title',
							6: 'Agency',
							7: 'Partner Organization',
							8: 'Project Site Location',
							9: 'Project Type',
							10: 'Other',
							11: 'Hazard Type',
							12: 'Project Resource Order Number',
							13: 'Staff Responsible',
							14: 'Project Description',
							15: 'Dispatch Date',
							16: 'Returned Date',
							17: 'IsPLC',
							18: 'Assignment Type',
							19: 'Comments',
							20: 'Project Verified',
							21: 'Entry Created',
							22: 'Entry Last Updated',
							23: 'Acres',
						});
						vm.summaryReport.forEach(function (item) {
							lst.push({
								0: item.FirstName,
								1: item.MiddleInitial,
								2: item.LastName,
								3: item.CISNo,
								4: item.JCCenter,
								5: item.ProjectTitle,
								6: item.Agency,
								7: item.PartnerOrganization,
								8: item.ProjectSiteLocation,
								9: item.ProjectType,
								10: item.ProjectTypeOther,
								11: item.HazardType,
								12: item.ProjectResourceOrderNo,
								13: item.StaffResponsible,
								14: item.ProjectDescription,
								15: item.DispatchDate,
								16: item.ReturnedDate,
								17: item.IsPLC,
								18: item.AssignmentType,
								19: item.Comments,
								20: item.ProjectVerified,
								21: item.CreatedDate,
								22: item.LastUpdated,
								23: item.Acres,
							});
						});
					}

					return lst;
				case 'vwCommunityHoursDetails':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({
						0: 'Total Actual Hours : ' + vm.totalField('ActualHours'),
					});
					lst.push({
						0: 'Center',
						1: 'Project Title',
						2: 'Student Name',
						3: 'Dispatch Date',
						4: 'Returned Date',
						5: 'Hours',
						6: 'Staff',
						7: 'Results Achieved',
						8: 'Project Partners',
						9: 'Lessons Learned',
						10: 'IsPLC',
						11: 'Entry Created',
						12: 'Entry Last updated',
						13: 'Created By',
						14: 'GAOA Hours',
						15: 'State',
						16: 'Justice40',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.JCCenter,
							1: item.ProjectDescription,
							2: item.StudentName,
							3: item.DispatchDate,
							4: item.ReturnedDate,
							5: item.ActualHours,
							6: item.Staff,
							7: item.ResultsAchieved,
							8: item.ProjectPartners,
							9: item.LessonsLearned,
							10: item.IsPLC,
							11: item.CreatedDate,
							12: item.UpdateDate,
							13: item.Creator,
							14: item.GAOAHours,
							15: item.State,
							16: item.Justice40,
						});
					});
					return lst;
				case 'vwPLCSummaryHoursByStudent':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({ 0: 'Total FS Hours : ' + vm.totalField('fsTotalHours') });
					lst.push({
						0: 'Total Fire Hours : ' + vm.totalField('fhTotalHours'),
					});
					lst.push({
						0:
							'Total Rural Development Hours : ' +
							vm.totalField('chTotalHours'),
					});
					lst.push({ 0: 'Total Hours : ' + vm.totalField('TotalHours') });
					lst.push({
						0: 'Fiscal Year',
						1: 'First Name',
						2: 'M.I.',
						3: 'Last Name',
						4: 'CIS No',
						5: 'PLC Cert',
						6: 'Placed',
						7: 'JC Center',
						8: 'JC Start Date',
						9: 'JC Grad. Dte.',
						10: 'Dispatch Date',
						11: 'Returned Date',
						12: 'Total FS Hours',
						13: 'Total Fire Hours',
						14: 'Total Rural Development Hours',
						15: 'Total Hours',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.CalendarYear,
							1: item.FirstName,
							2: item.MiddleInitial,
							3: item.LastName,
							4: item.CISNo,
							5: item.PLCCert,
							6: item.Placed,
							7: item.JCCenter,
							8: item.JCStartDate,
							9: item.JCGraduationDate,
							10: item.DispatchDate,
							11: item.ReturnedDate,
							12: item.fsTotalHours,
							13: item.fhTotalHours,
							14: item.chTotalHours,
							15: item.TotalHours,
						});
					});
					return lst;
				case 'vwSummary640Hours':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({ 0: 'Total FS Hours : ' + vm.totalField('fsTotalHours') });
					lst.push({
						0: 'Total Fire Hours : ' + vm.totalField('fhTotalHours'),
					});
					lst.push({
						0:
							'Total Rural Development Hours : ' +
							vm.totalField('chTotalHours'),
					});
					lst.push({ 0: 'Total Hours : ' + vm.totalField('TotalHours') });
					lst.push({
						0: 'First Name',
						1: 'MI',
						2: 'Last Name',
						3: 'CIS No',
						4: 'Center',
						5: 'JC Start Date',
						6: 'Dispatch Date',
						7: 'Return Date',
						8: 'FS Hours',
						9: 'Fire Hours',
						10: 'Rural Development Hours',
						11: 'Is PLC',
						12: 'Total Hours',
						13: 'PLC Certificate Date',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.FirstName,
							1: item.MiddleInitial,
							2: item.LastName,
							3: item.CISNo,
							4: item.JCCCC,
							5: item.JCStartDate,
							6: item.DispatchDate,
							7: item.ReturnedDate,
							8: item.fsTotalHours,
							9: item.fhTotalHours,
							10: item.chTotalHours,
							11: item.IsPLC,
							12: item.TotalHours,
							13: item.PLCCertificateDate,
						});
					});
					return lst;
				case 'vwFS180016Summary':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({ 0: 'Total Hours : ' + vm.totalField('Hours') });
					lst.push({ 0: 'Total Male Count : ' + vm.totalField('CountOfMale') });
					lst.push({
						0: 'Total Female Count : ' + vm.totalField('CountOfFemale'),
					});
					lst.push({
						0: 'Main Area',
						1: 'Sub Area',
						2: 'Partner Organization',
						3: 'Total Hours',
						4: 'Count of Male',
						5: 'Count of Female',
						6: 'Demographic',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.MainArea,
							1: item.SubArea,
							2: item.PartnerOrganization,
							3: item.Hours,
							4: item.CountOfMale,
							5: item.CountOfFemale,
							6: item.Demographic,
						});
					});
					return lst;
				case 'vwFireAssignmentSummary':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({
						0: 'Total Assignment Count : ' + vm.assignmentTypeTotal(),
					});
					lst.push({
						0: 'Total Fire Fighter Count : ' + vm.firefighterTotal(),
					});
					lst.push({
						0: 'Total Fire Fighter Hours : ' + vm.firefighterHoursTotal(),
					});
					lst.push({ 0: 'Total Camp Crew Count : ' + vm.campCrewTotal() });
					lst.push({ 0: 'Total Camp Crew Hours : ' + vm.campCrewHoursTotal() });
					lst.push({ 0: 'Total Project Count : ' + vm.projectCount() });
					lst.push({ 0: 'Total Hours : ' + vm.totalField('TotalHours') });
					lst.push({
						0: 'JCCCC',
						1: 'Assignment Type',
						2: 'Project Title',
						3: 'Proj. Resource OrderNo',
						4: 'Project Count',
						5: 'Total Hours',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.JCCCC,
							1: item.ResourceName,
							2: item.ProjectTitle,
							3: item.ProjectResourceOrderNo,
							4: item.ProjectCount,
							5: item.TotalHours,
						});
					});
					return lst;
				case 'vwNonFireFighterFireHireTrainingSummary':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({
						0: 'Total Students Trained : ' + vm.totalField('CountOfStudents'),
					});
					lst.push({
						0:
							'Total Fire Accepted AFMTP: ' +
							vm.totalField('FireAcceptedToAFMTP'),
					});
					lst.push({
						0: 'Total FS Fire Position : ' + vm.totalField('FSFirePosition'),
					});
					lst.push({
						0:
							'Total Other State Fire Position : ' +
							vm.totalField('OtherStateFederalFirePosition'),
					});
					lst.push({
						0:
							'Total Other Contract Fire Position : ' +
							vm.totalField('OtherContractFirePosition'),
					});
					lst.push({
						0:
							'Total Other Natural Resource Fire Position : ' +
							vm.totalField('OtherNaturalResourceFirePosition'),
					});
					lst.push({ 0: 'Total Hired : ' + vm.totalField('TotalHired') });
					lst.push({ 0: 'Total Hired Males : ' + vm.totalField('MaleCount') });
					lst.push({
						0: 'Total Hired Females : ' + vm.totalField('FemaleCount'),
					});
					lst.push({
						0: 'CalendarYear',
						1: 'JC Center',
						2: 'Fire Qualified FFT2',
						3: 'Fire Accepted AFMTP',
						4: 'FS Fire Position',
						5: 'Other State Fire Position',
						6: 'Other Contract Fire Position',
						7: 'Other NaturalResource Fire Position',
						8: 'Total Hired',
						9: '# Hired Males',
						10: '# Hired Females',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.CalendarYear,
							1: item.JCCenter,
							2: item.CountOfStudents,
							3: item.FireAcceptedToAFMTP,
							4: item.FSFirePosition,
							5: item.OtherStateFederalFirePosition,
							6: item.OtherContractFirePosition,
							7: item.OtherNaturalResourceFirePosition,
							8: item.TotalHired,
							9: item.MaleCount,
							10: item.FemaleCount,
						});
					});
					return lst;
				case 'vwFireHireTrainingSummary':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					vm.summaryReport.forEach(function (item) {
						lst.push({
							a: item.CalendarYear,
							firstName: item.JCCenter,
							MI: item.CountOfStudents,
							LastName: item.AFMTP,
							g9: item.FSFirePosition,
							g8: item.OtherStateFederalFirePosition,
							g7: item.OtherContractFirePosition,
							g2: item.OtherNaturalResourceFirePosition,
							g1: item.TotalHired,
							g0: item.MaleCount,
							g3: item.FemaleCount,
						});
					});
					return lst;
				case 'vwTotalProjectHoursByCenter':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({ 0: 'Total FS Hours : ' + vm.totalField('FSHours') });
					lst.push({ 0: 'Total Fire Hours : ' + vm.totalField('FireHours') });
					lst.push({
						0: 'Total Rural Development Hours : ' + vm.totalField('CommHours'),
					});
					lst.push({
						0: 'Total Project Hours : ' + vm.totalField('TotalHours'),
					});
					lst.push({
						0: 'Center',
						1: 'Forest Service',
						2: 'Fire',
						3: 'Rural Development',
						4: 'Total Project Hours',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.CenterName,
							1: item.FSHours,
							2: item.FireHours,
							3: item.CommHours,
							4: item.TotalHours,
						});
					});
					return lst;
				case 'vwScoreCard':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({ 0: 'Total Fire : ' + vm.totalField('Fire') });
					lst.push({
						0: 'Total Conservation : ' + vm.totalField('Conservation'),
					});
					lst.push({
						0:
							'Total Rural Development Services : ' +
							vm.totalField('CommunityServices'),
					});
					lst.push({
						0: 'Total Service Hours : ' + vm.totalField('TotalServiceHours'),
					});
					lst.push({
						0:
							'Total Conservation Apprenticeship Hires : ' +
							vm.totalField('TotalConservationApprenticeshipHires'),
					});
					lst.push({
						0:
							'Total Forest Service Apprenticeship Hires : ' +
							vm.totalField('ForestServiceApprenticeshipHires'),
					});
					lst.push({
						0:
							'Total Forest Service Public Land Corps Certificates : ' +
							vm.totalField('ForestServicePublicLandCorpsCertificates'),
					});
					lst.push({
						0: 'Center Name',
						1: 'Fire',
						2: 'Conservation',
						3: 'Rural Development',
						4: 'Total Hours',
						5: 'Total Apprenticeship Hires',
						6: 'Forest Service Apprenticeship Hires',
						7: 'PLC Certificates by center',
						8: 'GAOA Hours',
						9: 'HistoriCorps Hours',
						10: 'Acres',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.CenterName,
							1: item.Fire,
							2: item.Conservation,
							3: item.CommunityServices,
							4: item.TotalServiceHours,
							5: item.TotalConservationApprenticeshipHires,
							6: item.ForestServiceApprenticeshipHires,
							7: item.ForestServicePublicLandCorpsCertificates,
							8: item.GAOAHours,
							9: item.HistoriCorpsHours,
							10: item.Acres,
						});
					});
					return lst;
				case 'vwUsers':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({
						0: 'First Name',
						1: 'Last Name',
						2: 'Center',
						3: 'Email',
						4: 'Created Date',
						5: 'Last login date',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.FirstName,
							1: item.LastName,
							2: item.CenterName,
							3: item.Email,
							4: item.CreatedDate,
							5: item.LastLoginDate,
						});
					});
					return lst;
				case 'vwStudentsWithPLCCertificates':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({
						0: 'Center',
						1: 'Last Name',
						2: 'MI',
						3: 'First Name',
						4: 'Email',
						5: 'Phone number',
						6: 'Trade',
						7: 'Fire Position',
						8: 'Referred for job',
						9: 'Date PLC Received',
						10: 'Has Been Placed',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.CenterName,
							1: item.LastName,
							2: item.MI,
							3: item.FirstName,
							4: item.Email,
							5: item.Phone,
							6: item.Trade,
							7: item.ICSPosition,
							8: item.Referred,
							9: item.DatePLCRecieved,
							10: item.HasBeenPlaced,
						});
					});
					return lst;

				case 'vwStudentsReferredforForestJobs':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({
						0: 'Center',
						1: 'First Name',
						2: 'Last Name',
						3: 'Status',
						4: 'Student Bio',
						5: 'PLC Certs',
						6: 'Type of FS Job Interested In',
						7: 'Need a Mentor',
						8: 'Needing Internship (640hrs)',
						9: 'Date Available',
						10: 'Location of Interest',
						11: 'Resume Available',
						12: 'Email',
						13: 'Phone number',
						14: 'Trade',
						15: 'Hiring Authority',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.CenterName,
							1: item.FirstName,
							2: item.LastName,
							3: item.Status,
							4: item.StudentBio,
							5: item.PLCCert,
							6: item.DesiredFSJobType,
							7: item.NeedAMentor,
							8: item.NeedInternship,
							9: item.DateAvailable,
							10: item.DesiredJobLocation,
							11: item.ResumeAvailable,
							12: item.Email,
							13: item.Phone,
							14: item.Trade,
							15: item.HiringAuthority,
						});
					});
					return lst;
				//case 'vwStudentsReferredforForestJobs':
				//    lst.push({ 0: 'Date Ran Report : ' + ((new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear()) })
				//    lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name })
				//    lst.push({
				//        0: 'Center', 1: 'Last Name', 2: 'MI', 3: 'First Name', 4: 'Email', 5: 'Phone number', 6: 'Trade', 7: 'Fire Position', 8: 'Referred for job', 9: 'Date PLC Received', 10: 'Has Been Placed'
				//    })
				//    vm.summaryReport.forEach(function (item) {
				//        lst.push({
				//            0: item.CenterName, 1: item.LastName, 2: item.MI, 3: item.FirstName, 4: item.Email,
				//            5: item.Phone, 6: item.Trade, 7: item.ICSPosition, 8: item.Referred, 9: item.DatePLCRecieved, 10: item.HasBeenPlaced
				//        })
				//    })
				//    return lst;
				//    break;
				case 'vwStudentsReferredforConservationandFSJobs':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({
						0: 'Center',
						1: 'First Name',
						2: 'Last Name',
						3: 'Apprenticeship',
						4: 'Status',
						5: 'Student Bio',
						6: 'PLC Certs',
						7: 'Type of FS Job Interested In',
						8: 'Need a Mentor',
						9: 'Needing Internship (640hrs)',
						10: 'Date Available',
						11: 'Location of Interest',
						12: 'Resume Available',
						13: 'Email',
						14: 'Phone number',
						15: 'Trade',
						16: 'Hiring Authority',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.CenterName,
							1: item.FirstName,
							2: item.LastName,
							3: item.Apprenticeship,
							4: item.Status,
							5: item.StudentBio,
							6: item.PLCCert,
							7: item.DesiredFSJobType,
							8: item.NeedAMentor,
							9: item.NeedInternship,
							10: item.DateAvailable,
							11: item.DesiredJobLocation,
							12: item.ResumeAvailable,
							13: item.Email,
							14: item.Phone,
							15: item.Trade,
							16: item.HiringAuthority,
						});
					});
					return lst;

				case 'vwCommunityProjects':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({ 0: 'Total Hours : ' + vm.totalField('TotalHours') });
					lst.push({ 0: 'Total Students : ' + vm.totalField('TotalStudents') });
					lst.push({
						0: 'Center',
						1: 'Project Title',
						2: 'Dispatch Date',
						3: 'Return Date',
						4: 'Hours',
						5: 'Number of Students',
						6: 'Staff',
						7: 'Results Achieved',
						8: 'Project Partners',
						9: 'Lessons learned',
						10: 'Is PLC',
						11: 'Project Verified',
						12: 'Entry Created',
						13: 'Entry Last updated',
						14: 'GAOA Hours',
						15: 'Creator',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.CenterName,
							1: item.ProjectDescription,
							2: item.StartDate,
							3: item.EndDate,
							4: item.TotalHours,
							5: item.TotalStudents,
							6: item.StaffResponsible,
							7: item.ResultsAchieved,
							8: item.ProjectPartners,
							9: item.LessonsLearned,
							10: item.IsPLC,
							11: item.ProjectVerified,
							12: item.Created,
							13: item.Updated,
							14: item.TotalHours,
							15: item.Creator,
						});
					});
					return lst;

				case 'vwFireHoursProjects':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({ 0: 'Total Hours : ' + vm.totalField('Hours') });
					lst.push({ 0: 'Total Students : ' + vm.totalField('TotalStudents') });
					lst.push({
						0: 'JCCenter',
						1: 'Project Title',
						2: 'Dispatch Date',
						3: 'Return Date',
						4: 'Hours',
						5: 'Number of Students',
						6: 'Agency',
						7: 'Partner Organization',
						8: 'Project Site Location',
						9: 'Project Type',
						10: 'Other',
						11: 'Hazard Type',
						12: 'Project Resource Order Number',
						13: 'Staff Responsible',
						14: 'Project Description',
						15: 'IsPLC',
						16: 'Assignment Type',
						17: 'Comments',
						18: 'Project Verified',
						19: 'Creator',
						20: 'Entry Created',
						21: 'Entry Last Updated',
						22: 'Acres',
						23: 'State',
						24: 'Justice40',
						25: 'SPIS',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.JCCenter,
							1: item.ProjectTitle,
							2: item.DispatchDate,
							3: item.EndDate,
							4: item.ActualHours,
							5: item.TotalStudents,
							6: item.Agency,
							7: item.PartnerOrganization,
							8: item.ProjectSiteLocation,
							9: item.ProjectType,
							10: item.ProjectTypeOther,
							11: item.HazardType,
							12: item.ProjectResourceOrderNo,
							13: item.StaffResponsible,
							14: item.ProjectDescription,
							15: item.IsPLC,
							16: item.AssignmentType,
							17: item.Comments,
							18: item.ProjectVerified,
							19: item.Creator,
							20: item.CreatedDate,
							21: item.LastUpdated,
							22: item.Acres,
							23: item.State,
							24: item.Justice40,
							25: item.SPIS,
						});
					});
					return lst;

				case 'vwForestServiceProjects':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({ 0: 'Total Hours : ' + vm.totalField('Hours') });
					lst.push({ 0: 'Total Students : ' + vm.totalField('TotalStudents') });
					lst.push({
						0: 'Center',
						1: 'Project Title',
						2: 'Dispatch Date',
						3: 'Return Date',
						4: 'Hours',
						5: 'Number of Students',
						6: 'Staff',
						7: 'Focus Area',
						8: 'Sub Area',
						9: 'Partner Org',
						10: 'Project Site',
						11: 'Is PLC',
						12: 'Comments',
						13: 'Project Verified',
						14: 'Entry Created',
						15: 'Entry Last updated',
						16: 'GAOA Hours',
						17: 'HistoriCorps Hours',
						18: 'Creator',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.CenterName,
							1: item.ProjectName,
							2: item.StartDate,
							3: item.EndDate,
							4: item.Hours,
							5: item.TotalStudents,
							6: item.StaffResponsible,
							7: item.FocusArea,
							8: item.SubArea,
							9: item.PartnerOrg,
							10: item.ProjectSite,
							11: item.IsPLC,
							12: item.Description,
							13: item.ProjectVerified,
							14: item.Created,
							15: item.Updated,
							16: item.GAOAHours,
							17: item.HistoriCorpsHours,
							18: item.Creator,
						});
					});
					return lst;
				case 'vwIndividualStudentPLCHours':
					lst.push({
						0:
							'Date Ran Report : ' +
							(new Date().getMonth() +
								1 +
								'/' +
								new Date().getDate() +
								'/' +
								new Date().getFullYear()),
					});
					lst.push({ 0: 'Report Name : ' + vm.summaryReportType.name });
					lst.push({ 0: 'Total Hours : ' + vm.totalField('TotalHours') });
					lst.push({ 0: 'Total PLC Hours : ' + vm.totalField('PLCHours') });
					lst.push({
						0: 'Student Name',
						1: 'Project Name',
						2: 'Dispatch Date',
						3: 'Return Date',
						4: 'Total Hours',
						5: 'PLC Hours',
					});
					vm.summaryReport.forEach(function (item) {
						lst.push({
							0: item.StudentName,
							1: item.ProjectName,
							2: item.StartDate,
							3: item.EndDate,
							4: item.TotalHours,
							5: item.PLCHours,
						});
					});
					return lst;
				default:
					break;
			}
		};
		vm.getHeader = function () {
			switch (vm.summaryReportType.reportSource) {
				case 'vwStudentProfile':
					if (vm.summaryReportType.name == 'Placements Summary Report') {
						return [
							'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
						];
					}
					break;
				case 'vwForestServiceDetailedHours':
					return [
						'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
					];
				case 'vwFireProjectTypeAcresHoursSummary':
					return [
						'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
					];
				case 'vwFireHoursDetails':
					return [
						'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
					];
				case 'vwYouthAndVolunteerSummary':
					return [
						'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
					];
				case 'vwCommunityHoursDetails':
					return [
						'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
					];
				case 'vwPLCSummaryHoursByStudent':
					return [
						'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
					];
				case 'vwSummary640Hours':
					return [
						'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
					];
				case 'vwFS180016Summary':
					return [
						'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
					];
				case 'vwFireAssignmentSummary':
					return [
						'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
					];
				case 'vwNonFireFighterFireHireTrainingSummary':
					return [
						'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
					];
				case 'vwFireHireTrainingSummary':
					return [
						'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
					];
				case 'vwTotalProjectHoursByCenter':
					return [
						'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
					];
				case 'vwScoreCard':
					return [
						'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
					];
				case 'vwStudentsWithPLCCertificates':
					return [
						'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
					];
				case 'vwStudentsReferredforForestJobs':
					return [
						'From Available Date : ' +
							vm.startDate +
							' to Available Date : ' +
							vm.endDate,
					];
				case 'vwStudentsReferredforConservationandFSJobs':
					return [
						'From Available Date : ' +
							vm.startDate +
							' to Available Date : ' +
							vm.endDate,
					];
				case 'vwCommunityProjects':
					return [
						'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
					];
				case 'vwFireHoursProjects':
					return [
						'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
					];
				case 'vwForestServiceProjects':
					return [
						'From Date : ' + vm.startDate + ' to To Date : ' + vm.endDate,
					];

				default:
					break;
			}
		};
		activate();
		$scope.subscribe(
			events.message._GET_FIRE_HOUR_DATA_LIST_COMPLETE_,
			onGetFireHoursComplete
		);
		$scope.subscribe(
			events.message._GET_SUMMARY_REPORT_LIST_COMPLETE_,
			onGetSummaryReportComplete
		);
		$scope.subscribe(
			events.message._GET_SUMMARY_REPORT_LIST_FAILED_,
			onGetReportFailed
		);
		$scope.subscribe(
			events.message._GET_FIRE_SAFETY_DATA_LIST_COMPLETE_,
			onGetFireSafetyComplete
		);
		$scope.subscribe(
			events.message._GET_COMMUNITY_DATA_LIST_COMPLETE_,
			onGetCommunityComplete
		);
		$scope.subscribe(
			events.message._GET_STUDENT_FSHOURS_LIST_COMPLETE_,
			onGetStudentFSHoursComplete
		);
		$scope.subscribe(
			events.message._GET_STUDENT_FIREHOURS_LIST_COMPLETE_,
			onGetStudentFireHoursComplete
		);
		$scope.subscribe(
			events.message._GET_STUDENT_COMMUNITYHOURS_LIST_COMPLETE_,
			onGetStudentCommunityHoursComplete
		);
		$scope.subscribe(
			events.message._GET_FS1800_16_LIST_COMPLETE_,
			onGetFS1800Complete
		);
		$scope.subscribe(
			events.message._GET_YOUTHANDVOLUNTEER_LIST_COMPLETE_,
			onGetYouthAndVolunteerComplete
		);
		$scope.subscribe(
			events.message._GET_PLC_TOTAL_HOURS_LIST_COMPLETE_,
			onGetPLCTotalComplete
		);
		$scope.subscribe(
			events.message._GET_JCCENTER_LIST_COMPLETE_,
			onGetJcCentersComplete
		);
		$scope.subscribe(
			events.message._GET_PROJECT_RESOURCES_LIST_COMPLETE_,
			onGetProjectResourcesComplete
		);
		$scope.subscribe(
			events.message._GET_PROJECT_LIST_COMPLETE_,
			onGetProjectsComplete
		);
		$scope.subscribe(
			events.message._GET_STUDENT_RESOURCES_LIST_COMPLETE_,
			onGetStudentResourcesComplete
		);
		$scope.subscribe(events.message._GET_RSA_LIST_COMPLETE_, onGetRSAsComplete);
		function onGetRSAsComplete(results) {
			vm.rsas = results;
		}

		function fiscalYearUpdated(id) {
			if (id) {
				vm.startDate = '01/01/' + id;
				vm.endDate = '12/31/' + id;
			}

			//vm.projects = [];
			//vm.startPage = false;
			//if (id && vm.summaryReportType && (vm.summaryReportType.reportSource === "vwFireHoursDetails" || vm.summaryReportType.reportSource === "vwFireProjectTypeAcresHoursSummary" || vm.summaryReportType.reportSource === "vwFireAssignmentSummary")) {
			//    vm.filteredProjects = [];
			//    $scope.publish(events.message._GET_PROJECT_LIST_, [true, id]);
			//}
			//if (vm.summaryReportType.reportSource) {
			//    onGetJcCentersComplete(allCenters);
			//}
		}

		function centerChanged(id) {
			vm.projects = [];
			vm.startPage = false;
			if (
				id &&
				vm.summaryReportType &&
				(vm.summaryReportType.reportSource === 'vwFireHoursDetails' ||
					vm.summaryReportType.reportSource ===
						'vwFireProjectTypeAcresHoursSummary' ||
					vm.summaryReportType.reportSource === 'vwFireAssignmentSummary')
			) {
				vm.filteredProjects = [];
				$scope.publish(events.message._GET_PROJECT_LIST_, [true, id]);
			}
			if (vm.summaryReportType.reportSource) {
				onGetJcCentersComplete(allCenters);
			}
		}

		function onGetProjectsComplete(results) {
			vm.projects = results;
		}

		function onGetProjectResourcesComplete(results) {
			vm.resources = results;
		}
		function onGetStudentResourcesComplete(results) {
			vm.studentResources = results;
		}
		function clearResults() {
			vm.errorMessage = '';
			vm.fireHours = [];
			vm.fireSafety = [];
			vm.communityHours = [];
			vm.studentfireHours = [];
			vm.studentfireSafety = [];
			vm.studentcommunityHours = [];
			vm.fs1800_16 = [];
			vm.PLCTotalHours = [];
			vm.youthAndVolunteer = [];
			vm.summaryReport = [];
		}
		function activate() {
			if (
				authentication.userName === null ||
				authentication.userName === undefined ||
				!authentication.isAuth
			) {
				$scope.$state.go('login');
			}
			$scope.publish(events.message._GET_JCCENTER_LIST_, []);
			$scope.publish(events.message._GET_PROJECT_RESOURCES_LIST_, []);
			$scope.publish(events.message._GET_STUDENT_RESOURCES_LIST_, []);
			$scope.publish(events.message._GET_RSA_LIST_, []);
		}
		function onGetJcCentersComplete(results) {
			allCenters = results;
			//add condition for hide 'National office' options from center dropdown

			/*if (vm.summaryReportType.reportSource === "vwScoreCard" || vm.summaryReportType.reportSource === "vwTotalProjectHoursByCenter" ||
                vm.summaryReportType.reportSource === "vwFireHoursDetails" || vm.summaryReportType.reportSource === "vwForestServiceDetailedHours" || vm.summaryReportType.reportSource === "vwCommunityHoursDetails") {
                var tempData = [];
                $.each(results, function (e, val) {
                   (results[e].JCCCC != "National Office") ? tempData.push(results[e]) : "";
                })
                vm.centers = tempData;
            }else{
                vm.centers = results;
            }*/
			var tempData = [];
			$.each(results, function (e, val) {
				results[e].JCCCC != 'National Office' ? tempData.push(results[e]) : '';
			});
			vm.centers = tempData;
		}

		function onGetSummaryReportComplete(results) {
			if (
				vm.summaryReportType.reportSource === 'vwTotalProjectHoursByCenter' ||
				vm.summaryReportType.reportSource === 'vwScoreCard'
			) {
				var tempData = [];
				$.each(results, function (e, val) {
					results[e].CenterName != 'National Office'
						? tempData.push(results[e])
						: '';
				});
				allDataOfProjct = tempData; //store data into dynamic variable for filter functionality
				clearResults();
				vm.summaryReport = tempData;
			} else if (
				vm.summaryReportType.reportSource === 'vwForestServiceDetailedHours' ||
				vm.summaryReportType.reportSource === 'vwCommunityHoursDetails'
			) {
				var tempData = [];
				$.each(results, function (e, val) {
					results[e].JCCenter != 'National Office'
						? tempData.push(results[e])
						: '';
				});

				$.each(tempData, function (e, val) {
					tempData[e].IsPLC = tempData[e].IsPLC == true ? 'Yes' : 'No';
				});
				allDataOfProjct = tempData; //store data into dynamic variable for filter functionality
				clearResults();
				vm.summaryReport = tempData;
			} else if (vm.summaryReportType.reportSource === 'vwFireHoursDetails') {
				var tempData = [];
				$.each(results, function (e, val) {
					results[e].JCCenter != 'National Office'
						? tempData.push(results[e])
						: '';
				});

				$.each(tempData, function (e, val) {
					tempData[e].IsPLC = tempData[e].IsPLC == true ? 'Yes' : 'No';
					tempData[e].ProjectVerified =
						tempData[e].ProjectVerified == true ? 'Yes' : 'No';
				});
				allDataOfProjct = tempData; //store data into dynamic variable for filter functionality
				clearResults();
				vm.summaryReport = tempData;
			} else if (vm.summaryReportType.reportSource === 'vwFireHoursProjects') {
				var tempData = [];
				$.each(results, function (e, val) {
					results[e].JCCenter != 'National Office'
						? tempData.push(results[e])
						: '';
				});

				$.each(tempData, function (e, val) {
					tempData[e].IsPLC = tempData[e].IsPLC == true ? 'Yes' : 'No';
					tempData[e].ProjectVerified =
						tempData[e].ProjectVerified == true ? 'Yes' : 'No';
				});
				allDataOfProjct = tempData; //store data into dynamic variable for filter functionality
				clearResults();
				vm.summaryReport = tempData;
			} else {
				if (
					vm.summaryReportType.reportSource === 'vwCommunityProjects' ||
					vm.summaryReportType.reportSource === 'vwForestServiceProjects'
				) {
					var tempData = [];
					$.each(results, function (e, val) {
						results[e].CenterName != 'National Office'
							? tempData.push(results[e])
							: '';
					});
					$.each(tempData, function (e, val) {
						tempData[e].IsPLC = tempData[e].IsPLC == true ? 'Yes' : 'No';
						tempData[e].ProjectVerified =
							tempData[e].ProjectVerified == true ? 'Yes' : 'No';
					});
				} else if (vm.summaryReportType.reportSource === 'vwSummary640Hours') {
					var tempData = [];
					$.each(results, function (e, val) {
						results[e].JCCCC != 'National Office'
							? tempData.push(results[e])
							: '';
					});
					$.each(tempData, function (e, val) {
						tempData[e].IsPLC = tempData[e].IsPLC == true ? 'Yes' : 'No';
					});
				} else if (
					vm.summaryReportType.reportSource === 'vwStudentProfile' &&
					vm.summaryReportType.name == 'Student Profile Report'
				) {
					var tempData = [];
					$.each(results, function (e, val) {
						results[e].CenterName != 'National Office'
							? tempData.push(results[e])
							: '';
					});
					$.each(tempData, function (e, val) {
						tempData[e].Graduated =
							tempData[e].Graduated == true ? 'Yes' : 'No';
						tempData[e].ReferForJob =
							tempData[e].ReferForJob == true ? 'Yes' : 'No';
						tempData[e].EmploymentFirePlacement =
							tempData[e].EmploymentFirePlacement == true ? 'Yes' : 'No';
						tempData[e].PLCCertificateRecieved =
							tempData[e].PLCCertificateRecieved == true ? 'Yes' : 'No';
						tempData[e].PlacementVerified =
							tempData[e].PlacementVerified == true ? 'Yes' : 'No';
						tempData[e].GeneratePLCCertificate =
							tempData[e].GeneratePLCCertificate == true ? 'Yes' : 'No';
					});
				} else if (
					vm.summaryReportType.reportSource === 'vwStudentProfile' &&
					vm.summaryReportType.name == 'Placements Summary Report'
				) {
					var tempData = [];
					$.each(results, function (e, val) {
						results[e].CenterName != 'National Office'
							? tempData.push(results[e])
							: '';
					});
					$.each(tempData, function (e, val) {
						tempData[e].EmploymentFirePlacement =
							tempData[e].EmploymentFirePlacement == true ? 'Yes' : 'No';
						tempData[e].PlacementVerified =
							tempData[e].PlacementVerified == true ? 'Yes' : 'No';
					});
				} else if (
					vm.summaryReportType.reportSource === 'vwStudentProfile' &&
					vm.summaryReportType.name == 'Students with Maximum PLC Hours'
				) {
					var tempData = [];
					$.each(results, function (e, val) {
						results[e].CenterName != 'National Office'
							? tempData.push(results[e])
							: '';
					});
					$.each(tempData, function (e, val) {
						tempData[e].GeneratePLCCertificate =
							tempData[e].GeneratePLCCertificate == true ? 'Yes' : 'No';
					});
				} else if (
					vm.summaryReportType.reportSource === 'vwStudentEligibleHiring'
				) {
					var tempData = [];
					$.each(results, function (e, val) {
						results[e].CenterName != 'National Office'
							? tempData.push(results[e])
							: '';
					});
					$.each(tempData, function (e, val) {
						tempData[e].GeneratePLCCertificate =
							tempData[e].GeneratePLCCertificate == true ? 'Yes' : 'No';
					});
				} else if (
					vm.summaryReportType.reportSource === 'vwIndividualStudentPLCHours' ||
					vm.summaryReportType.reportSource === 'vwUsers'
				) {
					var tempData = [];
					$.each(results, function (e, val) {
						results[e].CenterName != 'National Office'
							? tempData.push(results[e])
							: '';
					});
				} else if (
					vm.summaryReportType.reportSource === 'vwStudentsWithPLCCertificates'
				) {
					var tempData = [];
					$.each(results, function (e, val) {
						results[e].CenterName != 'National Office'
							? tempData.push(results[e])
							: '';
					});
					$.each(tempData, function (e, val) {
						tempData[e].HasBeenPlaced =
							tempData[e].HasBeenPlaced == true ? 'Yes' : 'No';
					});
				} else if (
					vm.summaryReportType.reportSource ===
					'vwStudentsReferredforForestJobs'
				) {
					var tempData = [];
					$.each(results, function (e, val) {
						results[e].CenterName != 'National Office'
							? tempData.push(results[e])
							: '';
					});
					$.each(tempData, function (e, val) {
						tempData[e].HasBeenPlaced =
							tempData[e].HasBeenPlaced == true ? 'Yes' : 'No';
					});
				} else if (
					vm.summaryReportType.reportSource ===
					'vwStudentsReferredforConservationandFSJobs'
				) {
					var tempData = [];
					$.each(results, function (e, val) {
						results[e].CenterName != 'National Office'
							? tempData.push(results[e])
							: '';
					});
					$.each(tempData, function (e, val) {
						tempData[e].HasBeenPlaced =
							tempData[e].HasBeenPlaced == true ? 'Yes' : 'No';
					});
				} else if (vm.summaryReportType.reportSource === 'vwFS180016Summary') {
					var tempData = [];
					$.each(results, function (e, val) {
						results[e].CenterId != '29' ? tempData.push(results[e]) : '';
					});
				}
				allDataOfProjct = tempData; //store data into dynamic variable for filter functionality
				clearResults();
				vm.summaryReport = tempData;
			}
		}

		function onGetReportFailed(results) {
			clearResults();
			vm.errorMessage = 'No Records Returned';
		}

		function onGetFireHoursComplete(results) {
			clearResults();
			vm.fireHours = results;
		}
		function onGetFireSafetyComplete(results) {
			clearResults();
			vm.fireSafety = results;
		}
		function onGetCommunityComplete(results) {
			clearResults();
			vm.communityHours = results;
		}
		function onGetPLCTotalComplete(results) {
			clearResults();
			vm.PLCTotalHours = results;
		}
		function onGetYouthAndVolunteerComplete(results) {
			clearResults();
			vm.youthAndVolunteer = results;
		}
		function onGetFS1800Complete(results) {
			clearResults();
			vm.fs1800_16 = results;
		}
		function onGetStudentFireHoursComplete(results) {
			clearResults();
			vm.studentfireHours = results;
		}
		function onGetStudentFSHoursComplete(results) {
			clearResults();
			vm.studentfireSafety = results;
		}
		function onGetStudentCommunityHoursComplete(results) {
			clearResults();
			vm.studentcommunityHours = results;
		}
		$scope.$watch('vm.report', function (value) {
			if (value === 'PLC') {
				vm.isPLC = true;
				$scope.publish(events.message._GET_COMMUNITY_DATA_LIST_, [
					vm.calendarYear,
					vm.isPLC,
				]);
			} else if (value === 'FireHours') {
				$scope.publish(events.message._GET_FIRE_HOUR_DATA_LIST_, [
					vm.calendarYear,
				]);
			} else if (value === 'FireSafety') {
				$scope.publish(events.message._GET_FIRE_SAFETY_DATA_LIST_, [
					vm.calendarYear,
				]);
			} else if (value === 'Community') {
				vm.isPLC = false;
				$scope.publish(events.message._GET_COMMUNITY_DATA_LIST_, [
					vm.calendarYear,
					vm.isPLC,
				]);
			} else if (value === 'StudentFireHours') {
				$scope.publish(events.message._GET_STUDENT_FIREHOURS_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (value === 'StudentFireSafety') {
				$scope.publish(events.message._GET_STUDENT_FSHOURS_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (value === 'StudentCommunity') {
				$scope.publish(events.message._GET_STUDENT_COMMUNITYHOURS_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (value === 'PLCTotalHours') {
				$scope.publish(events.message._GET_PLC_TOTAL_HOURS_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (value === 'YouthAndVolunteer') {
				$scope.publish(events.message._GET_YOUTHANDVOLUNTEER_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (value === 'FS1800_16') {
				$scope.publish(events.message._GET_FS1800_16_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			}
		});
		$scope.$watch('vm.calendarYear', function (value) {
			if (vm.report === 'PLC') {
				vm.isPLC = true;
				$scope.publish(events.message._GET_COMMUNITY_DATA_LIST_, [
					vm.calendarYear,
					vm.isPLC,
				]);
			} else if (vm.report === 'FireHours') {
				$scope.publish(events.message._GET_FIRE_HOUR_DATA_LIST_, [
					vm.calendarYear,
				]);
			} else if (vm.report === 'FireSafety') {
				$scope.publish(events.message._GET_FIRE_SAFETY_DATA_LIST_, [
					vm.calendarYear,
				]);
			} else if (vm.report === 'Community') {
				vm.isPLC = false;
				$scope.publish(events.message._GET_COMMUNITY_DATA_LIST_, [
					vm.calendarYear,
					vm.isPLC,
				]);
			} else if (vm.report === 'StudentFireHours') {
				$scope.publish(events.message._GET_STUDENT_FIREHOURS_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (vm.report === 'StudentFireSafety') {
				$scope.publish(events.message._GET_STUDENT_FSHOURS_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (vm.report === 'StudentCommunity') {
				$scope.publish(events.message._GET_STUDENT_COMMUNITYHOURS_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (vm.report === 'PLCTotalHours') {
				$scope.publish(events.message._GET_PLC_TOTAL_HOURS_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (vm.report === 'YouthAndVolunteer') {
				$scope.publish(events.message._GET_YOUTHANDVOLUNTEER_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (vm.report === 'FS1800_16') {
				$scope.publish(events.message._GET_FS1800_16_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			}
		});
		$scope.$watch('vm.endDate', function (value) {
			if (vm.report === 'StudentFireHours') {
				$scope.publish(events.message._GET_STUDENT_FIREHOURS_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (vm.report === 'StudentFireSafety') {
				$scope.publish(events.message._GET_STUDENT_FSHOURS_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (vm.report === 'StudentCommunity') {
				$scope.publish(events.message._GET_STUDENT_COMMUNITYHOURS_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (vm.report === 'PLCTotalHours') {
				$scope.publish(events.message._GET_PLC_TOTAL_HOURS_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (vm.report === 'YouthAndVolunteer') {
				$scope.publish(events.message._GET_YOUTHANDVOLUNTEER_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (vm.report === 'FS1800_16') {
				$scope.publish(events.message._GET_FS1800_16_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			}
		});
		$scope.$watch('vm.startDate', function (value) {
			if (vm.report === 'StudentFireHours') {
				$scope.publish(events.message._GET_STUDENT_FIREHOURS_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (vm.report === 'StudentFireSafety') {
				$scope.publish(events.message._GET_STUDENT_FSHOURS_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (vm.report === 'StudentCommunity') {
				$scope.publish(events.message._GET_STUDENT_COMMUNITYHOURS_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (vm.report === 'PLCTotalHours') {
				$scope.publish(events.message._GET_PLC_TOTAL_HOURS_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (vm.report === 'YouthAndVolunteer') {
				$scope.publish(events.message._GET_YOUTHANDVOLUNTEER_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			} else if (vm.report === 'FS1800_16') {
				$scope.publish(events.message._GET_FS1800_16_LIST_, [
					vm.calendarYear,
					vm.startDate,
					vm.endDate,
				]);
			}
		});

		//filter function for filter data from reports table
		vm.filterDataFromTable = function (event) {
			var obj = [];
			if (allDataOfProjct.length > 0) {
				var t = allDataOfProjct.filter((itm) => {
					if (
						vm.summaryReportType.reportSource == 'vwTotalProjectHoursByCenter'
					) {
						obj = {
							CenterName: itm.CenterName,
							FSHours: itm.FSHours,
							FireHours: itm.FireHours,
							CommHours: itm.CommHours,
							TotalHours: itm.TotalHours,
						};
					} else if (vm.summaryReportType.reportSource == 'vwScoreCard') {
						obj = {
							CenterName: itm.CenterName,
							Fire: itm.Fire,
							Conservation: itm.Conservation,
							CommunityServices: itm.CommunityServices,
							TotalServiceHours: itm.TotalServiceHours,
							TotalConservationApprenticeshipHires:
								itm.TotalConservationApprenticeshipHires,
							ForestServiceApprenticeshipHires:
								itm.ForestServiceApprenticeshipHires,
							ForestServicePublicLandCorpsCertificates:
								itm.ForestServicePublicLandCorpsCertificates,
							Acres: itm.Acres,
						};
					} else if (
						vm.summaryReportType.reportSource == 'vwYouthAndVolunteerSummary'
					) {
						obj = {
							CalendarYear: itm.CalendarYear,
							RSAPartner: itm.RSAPartner,
							DeputyArea: itm.DeputyArea,
							TypeOfWork: itm.TypeOfWork,
							PartnerOrg: itm.PartnerOrg,
							ProgramPartnerType: itm.ProgramPartnerType,
							NationalForestGrasslands: itm.NationalForestGrasslands,
							FocusArea: itm.FocusArea,
							Gender: itm.Gender,
							GenderCount: itm.GenderCount,
							TotalHours: itm.TotalHours,
						};
					} else if (
						vm.summaryReportType.reportSource == 'vwFireAssignmentSummary'
					) {
						obj = {
							JCCCC: itm.JCCCC,
							ResourceName: itm.ResourceName,
							ProjectTitle: itm.ProjectTitle,
							ProjectResourceOrderNo: itm.ProjectResourceOrderNo,
							ProjectCount: itm.ProjectCount,
							TotalHours: itm.TotalHours,
						};
					} else if (
						vm.summaryReportType.reportSource ==
						'vwNonFireFighterFireHireTrainingSummary'
					) {
						obj = {
							CalendarYear: itm.CalendarYear,
							JCCenter: itm.JCCenter,
							CountOfStudents: itm.CountOfStudents,
							FireAcceptedToAFMTP: itm.FireAcceptedToAFMTP,
							FSFirePosition: itm.FSFirePosition,
							OtherStateFederalFirePosition: itm.OtherStateFederalFirePosition,
							OtherContractFirePosition: itm.OtherContractFirePosition,
							OtherNaturalResourceFirePosition:
								itm.OtherNaturalResourceFirePosition,
							TotalHired: itm.TotalHired,
							MaleCount: itm.MaleCount,
							FemaleCount: itm.FemaleCount,
						};
					} else if (
						vm.summaryReportType.reportSource == 'vwStudentProfile' &&
						vm.summaryReportType.name == 'Placements Summary Report'
					) {
						obj = {
							FirstName: itm.FirstName,
							MiddleInitial: itm.MiddleInitial,
							LastName: itm.LastName,
							CISNo: itm.CISNo,
							JCStartDate: itm.JCStartDate,
							CenterName: itm.CenterName,
							JCGraduationDate: itm.JCGraduationDate,
							EmploymentFirePlacement: itm.EmploymentFirePlacement,
							PlacementDate: itm.PlacementDate,
							Employer: itm.Employer,
							HiringAuthority: itm.HiringAuthority,
							PlacementType: itm.PlacementType,
							Apprenticeship: itm.Apprenticeship,
							JobTitle: itm.JobTitle,
							JobLocations: itm.JobLocations,
							Salary: itm.Salary,
							PlacementTypeOther: itm.PlacementTypeOther,
							PlacementVerified: itm.PlacementVerified,
							SupportingDocumentType: itm.SupportingDocumentType,
						};
					} else if (
						vm.summaryReportType.reportSource == 'vwStudentProfile' &&
						vm.summaryReportType.name == 'Students with Maximum PLC Hours'
					) {
						obj = {
							FirstName: itm.FirstName,
							MiddleInitial: itm.MiddleInitial,
							LastName: itm.LastName,
							CenterName: itm.CenterName,
							PLCHours: itm.PLCHours,
							GeneratePLCCertificate: itm.GeneratePLCCertificate,
						};
					} else if (
						vm.summaryReportType.reportSource == 'vwStudentEligibleHiring'
					) {
						obj = {
							FirstName: itm.FirstName,
							MiddleInitial: itm.MiddleInitial,
							LastName: itm.LastName,
							CenterName: itm.CenterName,
							PLCHours: itm.PLCHours,
							GeneratePLCCertificate: itm.GeneratePLCCertificate,
							WBLCompleted: itm.WBLCompleted,
							WBLStarted: itm.WBLStarted,
						};
					} else if (
						vm.summaryReportType.reportSource == 'vwStudentProfile' &&
						vm.summaryReportType.name == 'Student Profile Report'
					) {
						obj = {
							FirstName: itm.FirstName,
							MiddleInitial: itm.MiddleInitial,
							LastName: itm.LastName,
							Gender: itm.Gender,
							EducationLevel: itm.EducationLevel,
							CISNo: itm.CISNo,
							PrimaryPhoneNumber: itm.PrimaryPhoneNumber,
							PersonalEmailAddress: itm.PersonalEmailAddress,
							JCStartDate: itm.JCStartDate,
							CenterName: itm.CenterName,
							Credentials: itm.Credentials,
							ICSPosition: itm.ICSPosition,
							StudentTrade: itm.StudentTrade,
							JCGraduationDate: itm.JCGraduationDate,
							PlacementDate: itm.PlacementDate,
							Employer: itm.Employer,
							HiringAuthority: itm.HiringAuthority,
							PlacementType: itm.PlacementType,
							StudentBio: itm.StudentBio,
							SupervisorRemarks: itm.SupervisorRemarks,
							JobTitle: itm.JobTitle,
							Salary: itm.Salary,
							PLCCertificateRecieved: itm.PLCCertificateRecieved,
							PLCCertificateDate: itm.PLCCertificateDate,
							EmployerOther: itm.EmployerOther,
							Graduated: itm.Graduated,
							ReferForJob: itm.ReferForJob,
							PlacementTypeOther: itm.PlacementTypeOther,
							Apprenticeship: itm.Apprenticeship,
							CreatedDate: itm.CreatedDate,
							LastUpdated: itm.LastUpdated,
							EmploymentFirePlacement: itm.EmploymentFirePlacement,
							UnitLocation: itm.UnitLocation,
							fsTotalHours: itm.fsTotalHours,
							fhTotalHours: itm.fhTotalHours,
							chTotalHours: itm.chTotalHours,
							TotalHours: itm.TotalHours,
							PlacementVerified: itm.PlacementVerified,
							PLCHours: itm.PLCHours,
							FSPhoneNumber: itm.FSPhoneNumber,
							FSEmailAddress: itm.FSEmailAddress,
							GeneratePLCCertificate: itm.GeneratePLCCertificate,
							SupportingDocumentType: itm.SupportingDocumentType,
							AdminComments: itm.AdminComments,
						};
					} else if (
						vm.summaryReportType.reportSource == 'vwForestServiceDetailedHours'
					) {
						obj = {
							StudentName: itm.StudentName,
							JCCenter: itm.JCCenter,
							DispatchDate: itm.DispatchDate,
							FocusArea: itm.FocusArea,
							SubArea: itm.SubArea,
							ReturnedDate: itm.ReturnedDate,
							ActualHours: itm.ActualHours,
							ProjectName: itm.ProjectName,
							StaffResponsible: itm.StaffResponsible,
							PartnerOrg: itm.PartnerOrg,
							ProjectSite: itm.ProjectSite,
							IsPLC: itm.IsPLC,
							Comments: itm.Comments,
							CreatedDate: itm.CreatedDate,
							UpdateDate: itm.UpdateDate,
							Creator: itm.Creator,
							State: itm.State,
							Justice40: itm.Justice40,
						};
					} else if (
						vm.summaryReportType.reportSource ==
						'vwFireProjectTypeAcresHoursSummary'
					) {
						obj = {
							JCCenter: itm.JCCenter,
							ProjectType: itm.ProjectType,
							ProjectTitle: itm.ProjectTitle,
							Acres: itm.Acres,
							ActualHours: itm.ActualHours,
						};
					} else if (
						vm.summaryReportType.reportSource == 'vwFireHoursDetails'
					) {
						obj = {
							FirstName: itm.FirstName,
							MiddleInitial: itm.MiddleInitial,
							LastName: itm.LastName,
							CISNo: itm.CISNo,
							JCCenter: itm.JCCenter,
							Agency: itm.Agency,
							PartnerOrganization: itm.PartnerOrganization,
							ProjectSiteLocation: itm.ProjectSiteLocation,
							ProjectType: itm.ProjectType,
							ProjectResourceOrderNo: itm.ProjectResourceOrderNo,
							StaffResponsible: itm.StaffResponsible,
							CreatedDate: itm.CreatedDate,
							LastUpdated: itm.LastUpdated,
							ProjectTitle: itm.ProjectTitle,
							ProjectDescription: itm.ProjectDescription,
							DispatchDate: itm.DispatchDate,
							ReturnedDate: itm.ReturnedDate,
							IsPLC: itm.IsPLC,
							AssignmentType: itm.AssignmentType,
							ActualHours: itm.ActualHours,
							Comments: itm.Comments,
							ProjectTypeOther: itm.ProjectTypeOther,
							ProjectVerified: itm.ProjectVerified,
							Acres: itm.Acres,
							Creator: itm.Creator,
							State: itm.State,
							Justice40: itm.Justice40,
							SPIS: itm.SPIS,
						};
					} else if (
						vm.summaryReportType.reportSource == 'vwCommunityHoursDetails'
					) {
						obj = {
							StudentName: itm.StudentName,
							JCCenter: itm.JCCenter,
							DispatchDate: itm.DispatchDate,
							ReturnedDate: itm.ReturnedDate,
							ProjectDescription: itm.ProjectDescription,
							ActualHours: itm.ActualHours,
							Staff: itm.Staff,
							ResultsAchieved: itm.ResultsAchieved,
							ProjectPartners: itm.ProjectPartners,
							LessonsLearned: itm.LessonsLearned,
							IsPLC: itm.IsPLC,
							CreatedDate: itm.CreatedDate,
							UpdateDate: itm.UpdateDate,
							Creator: itm.Creator,
							State: itm.State,
							Justice40: itm.Justice40,
						};
					} else if (
						vm.summaryReportType.reportSource == 'vwPLCSummaryHoursByStudent'
					) {
						obj = {
							CalendarYear: itm.CalendarYear,
							FirstName: itm.FirstName,
							MiddleInitial: itm.MiddleInitial,
							LastName: itm.LastName,
							CISNo: itm.CISNo,
							PLCCert: itm.PLCCert,
							Placed: itm.Placed,
							JCCenter: itm.JCCenter,
							JCStartDate: itm.JCStartDate,
							JCGraduationDate: itm.JCGraduationDate,
							DispatchDate: itm.DispatchDate,
							ReturnedDate: itm.ReturnedDate,
							fsTotalHours: itm.fsTotalHours,
							fhTotalHours: itm.fhTotalHours,
							chTotalHours: itm.chTotalHours,
							TotalHours: itm.TotalHours,
						};
					} else if (vm.summaryReportType.reportSource == 'vwSummary640Hours') {
						obj = {
							FirstName: itm.FirstName,
							MiddleInitial: itm.MiddleInitial,
							LastName: itm.LastName,
							CISNo: itm.CISNo,
							PLCCertificateDate: itm.PLCCertificateDate,
							JCCCC: itm.JCCCC,
							DispatchDate: itm.DispatchDate,
							ReturnedDate: itm.ReturnedDate,
							fsTotalHours: itm.fsTotalHours,
							JCStartDate: itm.JCStartDate,
							fhTotalHours: itm.fhTotalHours,
							chTotalHours: itm.chTotalHours,
							TotalHours: itm.TotalHours,
							IsPLC: itm.IsPLC,
						};
					} else if (vm.summaryReportType.reportSource == 'vwFS180016Summary') {
						obj = {
							MainArea: itm.MainArea,
							SubArea: itm.SubArea,
							Hours: itm.Hours,
							CountOfMale: itm.CountOfMale,
							CountOfFemale: itm.CountOfFemale,
							PartnerOrganization: itm.PartnerOrganization,
							Demographic: itm.Demographic,
						};
					} else if (vm.summaryReportType.reportSource == 'vwUsers') {
						obj = {
							FirstName: itm.FirstName,
							LastName: itm.LastName,
							CenterName: itm.CenterName,
							Email: itm.Email,
							CreatedDate: itm.CreatedDate,
							LastLoginDate: itm.LastLoginDate,
						};
					} else if (
						vm.summaryReportType.reportSource == 'vwStudentsWithPLCCertificates'
					) {
						obj = {
							FirstName: itm.FirstName,
							LastName: itm.LastName,
							CenterName: itm.CenterName,
							Email: itm.Email,
							Phone: itm.Phone,
							Trade: itm.Trade,
							Referred: itm.Referred,
							DatePLCRecieved: itm.DatePLCRecieved,
							MI: itm.MI,
							ICSPosition: itm.ICSPosition,
							HasBeenPlaced: itm.HasBeenPlaced,
						};
					} else if (
						vm.summaryReportType.reportSource ==
						'vwStudentsReferredforForestJobs'
					) {
						obj = {
							FirstName: itm.FirstName,
							LastName: itm.LastName,
							CenterName: itm.CenterName,
							Email: itm.Email,
							Phone: itm.Phone,
							Trade: itm.Trade,
							Referred: itm.Referred,
							DatePLCRecieved: itm.DatePLCRecieved,
							MI: itm.MI,
							ICSPosition: itm.ICSPosition,
							HasBeenPlaced: itm.HasBeenPlaced,
							StudentBio: itm.StudentBio,
							PLCCert: itm.PLCCert,
							DesiredFSJobType: itm.DesiredFSJobType,
							DesiredJobLocation: itm.DesiredJobLocation,
							HiringAuthority: itm.HiringAuthority,
							Status: itm.Status,
							NeedAMentor: itm.NeedAMentor,
							NeedInternship: itm.NeedInternship,
							ResumeAvailable: itm.ResumeAvailable,
							DateAvailable: itm.DateAvailable,
						};
					} else if (
						vm.summaryReportType.reportSource ==
						'vwStudentsReferredforConservationandFSJobs'
					) {
						obj = {
							FirstName: itm.FirstName,
							LastName: itm.LastName,
							CenterName: itm.CenterName,
							Email: itm.Email,
							Phone: itm.Phone,
							Trade: itm.Trade,
							Referred: itm.Referred,
							DatePLCRecieved: itm.DatePLCRecieved,
							MI: itm.MI,
							ICSPosition: itm.ICSPosition,
							HasBeenPlaced: itm.HasBeenPlaced,
							StudentBio: itm.StudentBio,
							PLCCert: itm.PLCCert,
							DesiredFSJobType: itm.DesiredFSJobType,
							DesiredJobLocation: itm.DesiredJobLocation,
							HiringAuthority: itm.HiringAuthority,
							Status: itm.Status,
							NeedAMentor: itm.NeedAMentor,
							NeedInternship: itm.NeedInternship,
							ResumeAvailable: itm.ResumeAvailable,
							DateAvailable: itm.DateAvailable,
							Apprenticeship: item.Apprenticeship,
						};
					} else if (
						vm.summaryReportType.reportSource == 'vwCommunityProjects'
					) {
						obj = {
							ProjectDescription: itm.ProjectDescription,
							StartDate: itm.StartDate,
							CenterName: itm.CenterName,
							EndDate: itm.EndDate,
							StaffResponsible: itm.StaffResponsible,
							ResultsAchieved: itm.ResultsAchieved,
							ProjectPartners: itm.ProjectPartners,
							LessonsLearned: itm.LessonsLearned,
							Created: itm.Created,
							Updated: itm.Updated,
							IsPLC: itm.IsPLC,
							TotalHours: itm.TotalHours,
							TotalStudents: itm.TotalStudents,
							ProjectVerified: itm.ProjectVerified,
							GAOAHours: itm.GAOAHours,
							Creator: itm.Creator,
						};
					}

					//-----------------------------------------------------
					else if (vm.summaryReportType.reportSource == 'vwFireHoursProjects') {
						obj = {
							JCCenter: itm.JCCenter,
							ProjectTitle: itm.ProjectTitle,
							DispatchDate: itm.DispatchDate,
							EndDate: itm.EndDate,
							ActualHours: itm.ActualHours,
							TotalStudents: itm.TotalStudents,
							Agency: itm.Agency,
							PartnerOrganization: itm.PartnerOrganization,
							ProjectSiteLocation: itm.ProjectSiteLocation,
							ProjectType: itm.ProjectType,
							ProjectTypeOther: itm.ProjectTypeOther,
							HazardType: itm.HazardType,
							ProjectResourceOrderNo: itm.ProjectResourceOrderNo,
							ProjectDescription: itm.ProjectDescription,
							IsPLC: itm.IsPLC,
							AssignmentType: itm.AssignmentType,
							Comments: itm.Comments,
							ProjectVerified: itm.ProjectVerified,
							Creator: itm.Creator,
							CreatedDate: itm.CreatedDate,
							LastUpdated: itm.LastUpdated,
							Acres: itm.Acres,
							State: itm.State,
							Justice40: itm.Justice40,
							SPIS: itm.SPIS,
						};
					}
					//-----------------------------------------------------
					else if (
						vm.summaryReportType.reportSource == 'vwForestServiceProjects'
					) {
						obj = {
							ProjectName: itm.ProjectName,
							StartDate: itm.StartDate,
							CenterName: itm.CenterName,
							EndDate: itm.EndDate,
							StaffResponsible: itm.StaffResponsible,
							FocusArea: itm.FocusArea,
							SubArea: itm.SubArea,
							PartnerOrg: itm.PartnerOrg,
							ProjectSite: itm.ProjectSite,
							Created: itm.Created,
							Hours: itm.Hours,
							Updated: itm.Updated,
							IsPLC: itm.IsPLC,
							Description: itm.Description,
							TotalStudents: itm.TotalStudents,
							ProjectVerified: itm.ProjectVerified,
							GAOAHours: itm.GAOAHours,
							HistoriCorpsHours: itm.HistoriCorpsHours,
							Creator: itm.Creator,
						};
					} else if (
						vm.summaryReportType.reportSource == 'vwIndividualStudentPLCHours'
					) {
						obj = {
							StudentName: itm.StudentName,
							ProjectName: itm.ProjectName,
							StartDate: itm.StartDate,
							EndDate: itm.EndDate,
							TotalHours: itm.TotalHours,
							PLCHours: itm.PLCHours,
						};
					}

					var keys = Object.keys(obj);
					return keys.some((col) => {
						return (
							itm[col] &&
							itm[col]
								.toString()
								.toLowerCase()
								.indexOf(event.target.value.toLowerCase()) > -1
						);
					});
				});

				if (t.length == 0) {
					var obj = [];
					if (
						vm.summaryReportType.reportSource == 'vwTotalProjectHoursByCenter'
					) {
						obj.push({
							CenterId: '',
							CenterName: '',
							FSHours: '',
							FireHours: '',
							CommHours: '',
							ReportView: '',
							TotalHours: '',
						});
					} else if (vm.summaryReportType.reportSource == 'vwScoreCard') {
						obj.push({
							CenterId: '',
							CenterName: '',
							Fire: '',
							Conservation: '',
							CommunityServices: '',
							TotalServiceHours: '',
							TotalConservationApprenticeshipHires: '',
							ForestServiceApprenticeshipHires: '',
							ForestServicePublicLandCorpsCertificates: '',
							ReportView: '',
							PLCCertificateRecieved: '',
							Acres: '',
						});
					} else if (
						vm.summaryReportType.reportSource == 'vwYouthAndVolunteerSummary'
					) {
						obj.push({
							CenterId: '',
							CalendarYear: '',
							DeputyArea: '',
							DispatchDate: '',
							FocusArea: '',
							Gender: '',
							GenderCount: '',
							PartnerOrg: '',
							ProgramPartnerType: '',
							IsPLC: '',
							JCCenter: '',
							NationalForestGrasslands: '',
							RSAPartner: '',
							ReturnedDate: '',
							TotalHours: '',
							TypeOfWork: '',
							ReportView: '',
						});
					} else if (
						vm.summaryReportType.reportSource == 'vwFireAssignmentSummary'
					) {
						obj.push({
							CenterId: '',
							AssignmentCount: '',
							CalendarYear: '',
							Gender: '',
							GenderCount: '',
							JCCCC: '',
							ProjectCount: '',
							ProjectResourceOrderNo: '',
							ProjectTitle: '',
							ResourceName: '',
							TotalHours: '',
							ReportView: '',
						});
					} else if (
						vm.summaryReportType.reportSource ==
						'vwNonFireFighterFireHireTrainingSummary'
					) {
						obj.push({
							CenterId: '',
							AFMTP: '',
							CalendarYear: '',
							CountOfStudents: '',
							DispatchDate: '',
							FSFirePosition: '',
							FemaleCount: '',
							FireAcceptedToAFMTP: '',
							JCCenter: '',
							MaleCount: '',
							OtherContractFirePosition: '',
							OtherNaturalResourceFirePosition: '',
							OtherStateFederalFirePosition: '',
							ReturnedDate: '',
							TotalHired: '',
							ReportView: '',
						});
					} else if (
						vm.summaryReportType.reportSource == 'vwStudentEligibleHiring'
					) {
						obj.push({
							FirstName: '',
							MiddleInitial: '',
							LastName: '',
							CenterName: '',
							PLCHours: '',
							GeneratePLCCertificate: '',
							WBLCompleted: '',
							WBLStarted: '',
						});
					} else if (vm.summaryReportType.reportSource == 'vwStudentProfile') {
						obj.push({
							CISNo: '',
							CenterName: '',
							Credentials: '',
							EducationLevel: '',
							Employer: '',
							EmploymentFirePlacement: '',
							Ethnicity: '',
							FSEmailAddress: '',
							FSPhoneNumber: '',
							FirstName: '',
							Gender: '',
							HiringAuthority: '',
							ICSPosition: '',
							ICSTraineePosition: '',
							JCCCC: '',
							JCGraduationDate: '',
							LastName: '',
							JCStartDate: '',
							MiddleInitial: '',
							PersonalEmailAddress: '',
							PersonwithDisablilites: '',
							PlacementDate: '',
							PlacementType: '',
							PrimaryPhoneNumber: '',
							ReportView: '',
							StudentBio: '',
							StudentTrade: '',
							StudentType: '',
							SupervisorRemarks: '',
							Veteran: '',
							Active: '',
							Apprenticeship: '',
							ArchiveReason: '',
							ArchiveReasonOther: '',
							CreatedBy: '',
							CreatedDate: '',
							Creator: '',
							DOBMonthYear: '',
							Deleted: '',
							EmployerOther: '',
							Expr1: '',
							Expr2: '',
							Graduated: '',
							JobLocations: '',
							JobTitle: '',
							LastModifiedBy: '',
							LastUpdated: '',
							LastUpdatedBy: '',
							PLCCertificateDate: '',
							PLCCertificateRecieved: '',
							PlacementTypeOther: '',
							ReferForJob: '',
							Salary: '',
							StudentId: '',
							StudentPicture: '',
							UpdatingApp: '',
							UnitLocation: '',
							HasBeenPlaced: '',
							TotalHours: '',
							chTotalHours: '',
							fhTotalHours: '',
							fsTotalHours: '',
							PLCHours: '',
							GeneratePLCCertificate: '',
							PlacementVerified: '',
							SupportingDocumentType: '',
							OtherDocumentType: '',
							AdminComments: '',
						});
					} else if (
						vm.summaryReportType.reportSource == 'vwForestServiceDetailedHours'
					) {
						obj.push({
							ActualHours: '',
							CISNo: '',
							CalendarYear: '',
							CenterId: '',
							Comments: '',
							DispatchDate: '',
							FirstName: '',
							FocusArea: '',
							IsPLC: '',
							JCCenter: '',
							LastName: '',
							MiddleInitial: '',
							PartnerOrg: '',
							ReportView: '',
							Resource: '',
							ReturnedDate: '',
							SubArea: '',
							CreatedDate: '',
							UpdateDate: '',
							ProjectName: '',
							StaffResponsible: '',
							ProjectSite: '',
							StudentName: '',
							TotalProjects: '',
							Creator: '',
							State: '',
							Justice40: '',
						});
					} else if (
						vm.summaryReportType.reportSource ==
						'vwFireProjectTypeAcresHoursSummary'
					) {
						obj.push({
							Acres: '',
							ActualHours: '',
							Agency: '',
							AssignmentType: '',
							CISNo: '',
							CalendarYear: '',
							CenterId: '',
							Comments: '',
							DispatchDate: '',
							FirstName: '',
							IsPLC: '',
							JCCenter: '',
							JobCorpsCenter: '',
							LastName: '',
							MiddleInitial: '',
							PartnerOrganization: '',
							ProjectDescription: '',
							ProjectId: '',
							ProjectResourceOrderNo: '',
							ProjectSiteLocation: '',
							ProjectTitle: '',
							ProjectType: '',
							ReportView: '',
							ReturnedDate: '',
							WildlandUrbanInterface: '',
						});
					} else if (
						vm.summaryReportType.reportSource == 'vwFireHoursDetails'
					) {
						obj.push({
							Acres: '',
							ActualHours: '',
							Agency: '',
							AssignmentType: '',
							CISNo: '',
							CalendarYear: '',
							CenterId: '',
							Comments: '',
							DispatchDate: '',
							FirstName: '',
							IsPLC: '',
							JCCenter: '',
							JobCorpsCenter: '',
							LastName: '',
							MiddleInitial: '',
							PartnerOrganization: '',
							ProjectDescription: '',
							ProjectId: '',
							ProjectResourceOrderNo: '',
							ProjectSiteLocation: '',
							ProjectTitle: '',
							ProjectType: '',
							ReportView: '',
							ReturnedDate: '',
							WildlandUrbanInterface: '',
							CreatedDate: '',
							HazardType: '',
							LastUpdated: '',
							StaffResponsible: '',
							ProjectTypeOther: '',
							ProjectVerified: '',
							Acres: '',
							Creator: '',
							State: '',
							Justice40: '',
							SPIS: '',
						});
					} else if (
						vm.summaryReportType.reportSource == 'vwCommunityHoursDetails'
					) {
						obj.push({
							ActualHours: '',
							CISNo: '',
							CalendarYear: '',
							CenterId: '',
							CreatedDate: '',
							DispatchDate: '',
							FirstName: '',
							IsPLC: '',
							JCCenter: '',
							LastName: '',
							LessonsLearned: '',
							MiddleInitial: '',
							ProjectDescription: '',
							ProjectPartners: '',
							ReportView: '',
							ResultsAchieved: '',
							ReturnedDate: '',
							USDAInitiative: '',
							Staff: '',
							StudentName: '',
							UpdateDate: '',
							TotalProjects: '',
							Creator: '',
							State: '',
							Justice40: '',
						});
					} else if (
						vm.summaryReportType.reportSource == 'vwPLCSummaryHoursByStudent'
					) {
						obj.push({
							CISNo: '',
							CalendarYear: '',
							CenterId: '',
							DispatchDate: '',
							FirstName: '',
							JCCenter: '',
							JCGraduationDate: '',
							JCStartDate: '',
							LastName: '',
							MiddleInitial: '',
							PLCCert: '',
							Placed: '',
							ReportView: '',
							ReturnedDate: '',
							TotalHours: '',
							chTotalHours: '',
							fhTotalHours: '',
							fsTotalHours: '',
						});
					} else if (vm.summaryReportType.reportSource == 'vwSummary640Hours') {
						obj.push({
							CISNo: '',
							CalendarYear: '',
							CenterId: '',
							DispatchDate: '',
							FirstName: '',
							IsPLC: '',
							JCCCC: '',
							JCGraduationDate: '',
							JCStartDate: '',
							LastName: '',
							MiddleInitial: '',
							PLCCertificateDate: '',
							ReportView: '',
							ReturnedDate: '',
							TotalHours: '',
							chTotalHours: '',
							fhTotalHours: '',
							fsTotalHours: '',
						});
					} else if (vm.summaryReportType.reportSource == 'vwFS180016Summary') {
						obj.push({
							CalendarYear: '',
							CenterId: '',
							CountOfFemale: '',
							CountOfMale: '',
							Hours: '',
							IsPLC: '',
							MainArea: '',
							ReportView: '',
							SubArea: '',
							PartnerOrganization: '',
							Demographic: '',
						});
					} else if (vm.summaryReportType.reportSource == 'vwUsers') {
						obj.push({
							CenterName: '',
							CreatedDate: '',
							Email: '',
							FirstName: '',
							JCCCC: '',
							LastLoginDate: '',
							LastName: '',
							ReportView: '',
						});
					} else if (
						vm.summaryReportType.reportSource == 'vwStudentsWithPLCCertificates'
					) {
						obj.push({
							CenterName: '',
							DatePLCRecieved: '',
							Email: '',
							FirstName: '',
							LastName: '',
							Phone: '',
							Referred: '',
							ReportView: '',
							Trade: '',
							MI: '',
							ICSPosition: '',
							HasBeenPlaced: '',
						});
					} else if (
						vm.summaryReportType.reportSource ==
						'vwStudentsReferredforForestJobs'
					) {
						obj.push({
							CenterName: '',
							DatePLCRecieved: '',
							Email: '',
							FirstName: '',
							LastName: '',
							Phone: '',
							Referred: '',
							ReportView: '',
							Trade: '',
							MI: '',
							ICSPosition: '',
							HasBeenPlaced: '',
							StudentBio: '',
							PLCCert: '',
							DesiredFSJobType: '',
							DesiredJobLocation: '',
							HiringAuthority: '',
							Status: '',
							NeedAMentor: '',
							NeedInternship: '',
							ResumeAvailable: '',
							DateAvailable: '',
						});
					} else if (
						vm.summaryReportType.reportSource ==
						'vwStudentsReferredforConservationandFSJobs'
					) {
						obj.push({
							CenterName: '',
							DatePLCRecieved: '',
							Email: '',
							FirstName: '',
							LastName: '',
							Phone: '',
							Referred: '',
							ReportView: '',
							Trade: '',
							MI: '',
							ICSPosition: '',
							HasBeenPlaced: '',
							StudentBio: '',
							PLCCert: '',
							DesiredFSJobType: '',
							DesiredJobLocation: '',
							HiringAuthority: '',
							Status: '',
							NeedAMentor: '',
							NeedInternship: '',
							ResumeAvailable: '',
							DateAvailable: '',
							Apprenticeship: '',
						});
					} else if (
						vm.summaryReportType.reportSource == 'vwCommunityProjects'
					) {
						obj.push({
							CenterName: '',
							Created: '',
							EndDate: '',
							LessonsLearned: '',
							ProjectDescription: '',
							ProjectPartners: '',
							ResultsAchieved: '',
							ReportView: '',
							StaffResponsible: '',
							StartDate: '',
							USDAInitiative: '',
							Updated: '',
							IsPLC: '',
							TotalHours: '',
							TotalStudents: '',
							ProjectVerified: '',
							Creator: '',
						});
					} else if (
						vm.summaryReportType.reportSource == 'vwFireHoursProjects'
					) {
						obj.push({
							JCCenter: '',
							ProjectTitle: '',
							DispatchDate: '',
							EndDate: '',
							ActualHours: '',
							TotalStudents: '',
							Agency: '',
							PartnerOrganization: '',
							ProjectSiteLocation: '',
							ProjectType: '',
							ProjectTypeOther: '',
							HazardType: '',
							ProjectResourceOrderNo: '',
							StaffResponsible: '',
							ProjectDescription: '',
							IsPLC: '',
							AssignmentType: '',
							Comments: '',
							ProjectVerified: '',
							Creator: '',
							CreatedDate: '',
							LastUpdated: '',
							Acres: '',
							State: '',
							Justice40: '',
							SPIS: '',
						});
					} else if (
						vm.summaryReportType.reportSource == 'vwForestServiceProjects'
					) {
						obj.push({
							CenterName: '',
							Created: '',
							EndDate: '',
							FocusArea: '',
							PartnerOrg: '',
							ProjectName: '',
							ProjectSite: '',
							Description: '',
							Hours: '',
							IsPLC: '',
							ReportView: '',
							StaffResponsible: '',
							StartDate: '',
							SubArea: '',
							Updated: '',
							TotalStudents: '',
							ProjectVerified: '',
							Creator: '',
						});
					} else if (
						vm.summaryReportType.reportSource == 'vwIndividualStudentPLCHours'
					) {
						obj.push({
							StudentName: '',
							ProjectName: '',
							StartDate: '',
							EndDate: '',
							TotalHours: '',
							PLCHours: '',
							ReportView: '',
							CenterId: '',
							CenterName: '',
						});
					}

					vm.summaryReport = obj;
				} else {
					vm.summaryReport = t;
				}
			}
		};
	}
})();
